<template>
    <van-pull-refresh
            style="min-height: 100vh; background-color: #f0f2f5; padding-bottom: 56px;"
            v-model="isLoading"
            success-text="刷新成功"
            @refresh="onRefresh"
    >
        <!-- ========================================== -->
        <!-- 板块一：会员信息 Member Profile Section -->
        <!-- ========================================== -->
        <div class="tg-section" style="margin-top: 8px;">
            <div class="tg-card tg-profile-card">
                <!-- 头部：头像 + 用户名 + VIP -->
                <div class="tg-profile-header">
                    <div class="tg-avatar-wrap">
                        <img
                                v-if="avatarUrl && avatarUrl.length > 0"
                                :src="avatarUrl"
                                class="tg-avatar-img"
                                @error="onAvatarError"
                        />
                        <div v-else class="tg-avatar" :style="{ background: getAvatarColor(displayName) }">
                            <span class="tg-avatar-letter">{{ getFirstLetter(displayName) }}</span>
                        </div>
                    </div>
                    <div class="tg-profile-info">
                        <div class="tg-name-row">
                            <span class="tg-username">{{ displayName }}</span>
                        </div>
                        <div class="tg-phone-row">
                            <van-icon name="phone-o" size="16" color="#8e8e93" />
                            <span class="tg-phone">{{ formattedPhone }}</span>
                        </div>
                        <div class="tg-username-row">
                            <svg class="tg-username-icon" viewBox="0 0 24 24" width="16" height="16" fill="#8e8e93">
                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10h5v-2h-5c-4.34 0-8-3.66-8-8s3.66-8 8-8 8 3.66 8 8v1.43c0 .79-.71 1.57-1.5 1.5s-1.5-.78-1.5-1.57V12c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5c1.38 0 2.64-.56 3.54-1.47.65.89 1.77 1.47 2.96 1.47 1.97 0 3.5-1.6 3.5-3.57V12c0-5.52-4.48-10-10-10zm0 13c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"/>
                            </svg>
                            <span v-if="hasUsername" class="tg-username-at">@{{ username }}</span>
                            <span v-else class="tg-username-at" style="color: #999;">@username</span>
                        </div>
                    </div>
                </div>

                <div class="tg-info-list">
                    <div class="tg-info-item">
                        <div class="tg-info-icon blue">
                            <svg viewBox="0 0 24 24" width="11" height="11" fill="currentColor">
                                <path d="M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48C13.85 1.23 12.95 1 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31C6.97 3.26 6 5.01 6 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zm5 0h-1V4h1v1z"/>
                            </svg>
                        </div>
                        <span class="tg-info-label">设备标识</span>
                        <span class="tg-info-value device-code">{{ Imei || '获取中...' }}</span>
                    </div>

                    <div class="tg-divider"></div>

                    <div class="tg-info-item">
                        <div class="tg-info-icon purple">
                            <svg viewBox="0 0 24 24" width="12" height="12" fill="currentColor">
                                <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
                            </svg>
                        </div>
                        <span class="tg-info-label">订阅时间</span>
                        <span class="tg-info-value">{{ end_Time || '未开通' }}</span>
                    </div>

                    <div class="tg-divider"></div>

                    <div class="tg-info-item">
                        <div class="tg-info-icon" :class="isActive ? 'green' : 'red'">
                            <svg v-if="isActive" viewBox="0 0 24 24" width="12" height="12" fill="currentColor">
                                <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"/>
                            </svg>
                            <svg v-else viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
                                <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
                            </svg>
                        </div>
                        <span class="tg-info-label">订阅状态</span>
                        <span class="tg-info-value status">{{ status }}</span>
                        <div class="tg-network-status">
                            <img v-if="isActive" src="../assets/lv.gif" class="network-gif" alt="connected" />
                            <img v-else src="../assets/hei.gif" class="network-gif" alt="disconnected" />
                        </div>
                    </div>

                    <div class="tg-divider"></div>

                    <!-- 频道和群组入口行 -->
                    <div class="tg-info-item community-item">
                        <div class="tg-info-icon teal">
                            <van-icon name="user-o" size="12" color="#fff" />
                        </div>
                        <span class="tg-info-label">频道群组</span>
                        <div class="tg-community-btns">
                            <button class="tg-community-btn channel" @click="openChannel">
                                <van-icon name="bullhorn-o" size="10" />
                                <span>进入频道</span>
                            </button>
                            <button class="tg-community-btn group" @click="openGroup">
                                <van-icon name="friends" size="10" />
                                <span>进入群组</span>
                            </button>
                        </div>
                    </div>

                    <div class="tg-divider"></div>

                    <!-- 联系客服行 -->
                    <div class="tg-info-item service-item">
                        <div class="tg-info-icon service">
                            <van-icon name="service-o" size="12" color="#fff" />
                        </div>
                        <span class="tg-info-label">联系客服</span>
                        <div class="tg-service-btns">
                            <button class="tg-service-btn" @click="openService">
                                <van-icon name="chat-o" size="10" />
                                <span>人工客服</span>
                            </button>
                            <button class="tg-service-btn robot" @click="openRobotService">
                                <van-icon name="smile-o" size="10" />
                                <span>双向客服机器人</span>
                            </button>
                        </div>
                    </div>

                    <div class="tg-divider"></div>

                    <!-- 下载网址行 -->
                    <div class="tg-info-item website-item">
                        <div class="tg-info-icon browser">
                            <svg viewBox="0 0 24 24" width="12" height="12" fill="currentColor">
                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
                            </svg>
                        </div>
                        <span class="tg-info-label">下载网址</span>
                        <span class="tg-info-value website-value">www.Telegram.tw</span>
                        <button class="tg-copy-share-btn" @click="copyWebsite">
                            <svg viewBox="0 0 24 24" width="10" height="10" fill="currentColor" style="margin-right: 2px;">
                                <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
                            </svg>
                            <span>复制分享</span>
                        </button>
                    </div>

                </div>
            </div>
        </div>

        <!-- ========================================== -->
        <!-- 板块二：全新精致导航栏（横向图标+文字） -->
        <!-- ========================================== -->
        <div class="tg-section">
            <div class="tg-nav-card-refined" ref="navTrack">
                <div class="tg-nav-item-refined" :class="{ active: activeTab === 0 }" @click="switchTab(0)">
                    <van-icon name="cluster-o" size="14" :color="activeTab === 0 ? '#ffffff' : '#24A1DE'" />
                    <span>订阅MTProto</span>
                </div>
                <div class="tg-nav-item-refined" :class="{ active: activeTab === 1 }" @click="switchTab(1)">
                    <van-icon name="gem-o" size="14" :color="activeTab === 1 ? '#ffffff' : '#8b5cf6'" />
                    <span>增值服务</span>
                </div>
                <div class="tg-nav-indicator-refined" :style="indicatorStyle"></div>
            </div>
        </div>

        <!-- ========================================== -->
        <!-- 内容区域：Tab切换 -->
        <!-- ========================================== -->
        <!-- Tab 0: 订阅（原有内容） -->
        <div v-if="activeTab === 0" class="tg-tab-content">
            <!-- ========================================== -->
            <!-- 板块三：订阅MTProto高速通道 -->
            <!-- ========================================== -->
            <div class="tg-section">
                <div class="tg-card tg-subscription-card">
                    <div class="tg-sub-header">
                        <div class="tg-sub-icon-solid">
                            <van-icon name="cluster" size="14" color="#fff" />
                        </div>
                        <span class="tg-sub-title">订阅 • MTProto高速通道</span>
                    </div>

                    <div class="tg-pay-section-card">
                        <van-radio-group v-model="payChannel" :key="renderKey" @change="switchChannel">
                            <div class="tg-pay-row" :class="{ active: payChannel === 'alipay' }" @click="payChannel = 'alipay'">
                                <div class="tg-pay-content">
                                    <van-radio name="alipay" icon-size="16px" />
                                    <span class="tg-pay-name">支付宝</span>
                                    <van-image width="2.2rem" height="1.4rem" fit="cover" :src="require('../assets/alipay.svg')" />
                                </div>
                            </div>
                            <div class="tg-pay-divider"></div>
                            <div class="tg-pay-row" :class="{ active: payChannel === 'card' }" @click="payChannel = 'card'">
                                <div class="tg-pay-content">
                                    <van-radio name="card" icon-size="16px" />
                                    <span class="tg-pay-name">银行卡 信用卡</span>
                                    <div class="tg-pay-cards-inline">
                                        <van-image width="1.6rem" height="1rem" fit="cover" :src="require('../assets/unionpay.svg')" />
                                        <van-image width="1.6rem" height="1rem" fit="cover" :src="require('../assets/visa.svg')" />
                                        <van-image width="1.6rem" height="1rem" fit="cover" :src="require('../assets/mastercard.svg')" />
                                        <van-image width="1.6rem" height="1rem" fit="cover" :src="require('../assets/jcb.svg')" />
                                        <van-image width="1.6rem" height="1rem" fit="cover" :src="require('../assets/amex.svg')" />
                                    </div>
                                </div>
                            </div>
                            <div class="tg-pay-divider"></div>
                            <div class="tg-pay-row" :class="{ active: payChannel === 'usdt' }" @click="payChannel = 'usdt'">
                                <div class="tg-pay-content">
                                    <van-radio name="usdt" icon-size="16px" />
                                    <span class="tg-pay-name">USDT (TRC20)</span>
                                    <van-image width="22px" height="22px" fit="cover" :src="require('../assets/usdt.svg')" />
                                </div>
                            </div>
                            <div class="tg-pay-divider"></div>
                            <div class="tg-pay-row" :class="{ active: payChannel === 'trx' }" @click="payChannel = 'trx'">
                                <div class="tg-pay-content">
                                    <van-radio name="trx" icon-size="16px" />
                                    <span class="tg-pay-name">TRX</span>
                                    <van-image width="22px" height="22px" fit="cover" :src="require('../assets/trx.svg')" />
                                </div>
                            </div>
                        </van-radio-group>
                    </div>

                    <div class="tg-sub-list">
                        <div class="tg-sub-item yellow" @click="buy(packages[0])">
                            <div class="tg-sub-main">
                                <span class="tg-sub-time">1个月</span>
                                <span class="tg-sub-divider">|</span>
                                <span class="tg-sub-label">轻享月包</span>
                                <span class="tg-sub-save yellow">按月付</span>
                            </div>
                            <div class="tg-sub-right">
                                <span class="tg-sub-price">¥38</span>
                                <span class="tg-sub-btn yellow">点击订阅</span>
                            </div>
                        </div>

                        <div class="tg-sub-item yellow" @click="buy(packages[1])">
                            <div class="tg-sub-main">
                                <span class="tg-sub-time">3个月</span>
                                <span class="tg-sub-divider">|</span>
                                <span class="tg-sub-label">季度优惠</span>
                                <span class="tg-sub-save yellow">省16元</span>
                            </div>
                            <div class="tg-sub-right">
                                <span class="tg-sub-price">¥98</span>
                                <span class="tg-sub-btn yellow">点击订阅</span>
                            </div>
                        </div>

                        <div class="tg-sub-item yellow" @click="buy(packages[2])">
                            <div class="tg-sub-main">
                                <span class="tg-sub-time">6个月</span>
                                <span class="tg-sub-divider">|</span>
                                <span class="tg-sub-label">半年特惠</span>
                                <span class="tg-sub-save yellow">省60元</span>
                            </div>
                            <div class="tg-sub-right">
                                <span class="tg-sub-price">¥168</span>
                                <span class="tg-sub-btn yellow">点击订阅</span>
                            </div>
                        </div>

                        <div class="tg-sub-item yellow" @click="buy(packages[3])">
                            <div class="tg-sub-main">
                                <span class="tg-sub-time">12个月</span>
                                <span class="tg-sub-divider">|</span>
                                <span class="tg-sub-label">年度尊享</span>
                                <span class="tg-sub-save yellow">省158元</span>
                            </div>
                            <div class="tg-sub-right">
                                <span class="tg-sub-price">¥298</span>
                                <span class="tg-sub-btn yellow">点击订阅</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ========================================== -->
            <!-- 板块四：邀请中心（合并卡片） -->
            <!-- ========================================== -->
            <div class="tg-section">
                <div class="tg-card tg-invite-center-card">
                    <!-- 上部：开始邀请 -->
                    <div class="tg-invite-center-top">
                        <!-- 头部：邀请获赠标题 + 副标题 -->
                        <div class="tg-invite-header">
                            <div class="tg-invite-icon-wrap">
                                <van-icon name="friends" size="16" color="#fff" />
                            </div>
                            <span class="tg-invite-title">
                                邀请获赠 •
                                <span class="tg-invite-subtitle-inline">邀请好友登录 获赠订阅时长</span>
                            </span>
                        </div>

                        <!-- 加载中状态 -->
                        <div v-if="referralLoading" class="tg-invite-loading">
                            <van-loading type="spinner" size="24" color="#0ea5e9" />
                            <span class="loading-text">加载中...</span>
                        </div>

                        <!-- 加载完成后显示内容 -->
                        <template v-else>
                            <!-- 邀请码 + 邀请链接 合并区域（新样式） -->
                            <div class="tg-invite-code-section-v2">
                                <!-- 我的邀请码 -->
                                <div class="tg-invite-code-main-v2">
                                    <div class="tg-invite-code-label-v2">我的邀请码</div>
                                    <span class="tg-invite-code-text-v2">{{ inviteCode || '加载中...' }}</span>
                                </div>

                                <!-- 精致分隔线：中间圆点 + 两边渐变线 -->
                                <div class="tg-invite-divider-v2">
                                    <div class="divider-line-v2 left"></div>
                                    <div class="divider-dot-v2"></div>
                                    <div class="divider-line-v2 right"></div>
                                </div>

                                <!-- 我的邀请链接 -->
                                <div class="tg-invite-link-label-v2">我的邀请链接</div>

                                <!-- 邀请链接完整显示 + 复制按钮移到下方 -->
                                <div class="tg-invite-link-full">
                                    <span class="tg-invite-link-full-text">{{ inviteLink || '加载中...' }}</span>
                                </div>
                                <button
                                        class="tg-invite-copy-btn-bottom"
                                        @click="copyInviteLink"
                                        :class="{ 'copied': inviteCopied }"
                                >
                                    <van-icon :name="inviteCopied ? 'success' : 'copy'" size="14" />
                                    <span>{{ inviteCopied ? '已复制' : '复制邀请链接' }}</span>
                                </button>
                            </div>

                            <!-- 复制链接提示 -->
                            <div class="tg-invite-hint">
                                <van-icon name="info-o" size="12" color="#0ea5e9" />
                                <span>复制邀请链接发给好友<br>好友安装登录后，您即可获赠7天订阅时长。</span>
                            </div>

                            <!-- 已绑定邀请人提示 -->
                            <div v-if="hasParent && parentInviteCode" class="tg-bind-success-banner">
                                <div class="bind-success-inner">
                                    <div class="bind-success-icon">
                                        <van-icon name="certificate" size="14" color="#fff" />
                                    </div>
                                    <div class="bind-success-text">
                                        <span class="bind-success-label">您的邀请人</span>
                                        <span class="bind-success-code">{{ parentInviteCode }}</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>

                    <!-- 分隔线 -->
                    <div class="tg-invite-center-divider"></div>

                    <!-- 下部：邀请获赠统计 -->
                    <div class="tg-invite-center-bottom">
                        <!-- 头部：查看邀请记录按钮 -->
                        <div class="tg-referral-header">
                            <button class="tg-view-history-btn" @click="showInviteHistory">
                                <van-icon name="records" size="12" />
                                <span>查看邀请记录</span>
                            </button>
                        </div>

                        <!-- 统计数据 -->
                        <div class="tg-referral-stats">
                            <div class="tg-referral-stat-item">
                                <div class="tg-referral-stat-value">{{ inviteStats.totalInvites }}人</div>
                                <div class="tg-referral-stat-header">
                                    <div class="tg-referral-stat-icon">
                                        <svg class="tg-icon-trophy" viewBox="0 0 24 24" width="18" height="18" fill="#f59e0b">
                                            <path d="M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H7v2h10v-2h-4v-3.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM5 8V7h2v3.1C5.72 9.76 5 8.92 5 8zm14 0c0 .92-.72 1.76-1.64 2.1V7h2v1z"/>
                                        </svg>
                                    </div>
                                    <span class="tg-referral-stat-label">累计邀请</span>
                                </div>
                            </div>

                            <div class="tg-referral-stat-divider"></div>

                            <div class="tg-referral-stat-item">
                                <div class="tg-referral-stat-value">{{ inviteStats.monthInvites }}人</div>
                                <div class="tg-referral-stat-header">
                                    <div class="tg-referral-stat-icon">
                                        <svg class="tg-icon-fire" viewBox="0 0 24 24" width="18" height="18" fill="#ef4444">
                                            <path d="M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-1.83 4.8-4.8 4.8z"/>
                                        </svg>
                                    </div>
                                    <span class="tg-referral-stat-label">本月邀请</span>
                                </div>
                            </div>

                            <div class="tg-referral-stat-divider"></div>

                            <div class="tg-referral-stat-item">
                                <div class="tg-referral-stat-value highlight">+{{ inviteStats.totalGiftDays }}天</div>
                                <div class="tg-referral-stat-header">
                                    <div class="tg-referral-stat-icon">
                                        <svg class="tg-icon-gift" viewBox="0 0 24 24" width="18" height="18" fill="#0ea5e9">
                                            <path d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"/>
                                        </svg>
                                    </div>
                                    <span class="tg-referral-stat-label">累计获赠</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ========================================== -->
            <!-- 【新增】板块四-2：邀请奖励卡片 -->
            <!-- ========================================== -->
            <div class="tg-section">
                <div class="tg-card tg-rebate-card">
                    <!-- 上部：奖励标题 -->
                    <div class="tg-rebate-top">
                        <div class="tg-rebate-header">
                            <div class="tg-rebate-icon-wrap">
                                <van-icon name="gold-coin" size="16" color="#fff" />
                            </div>
                            <span class="tg-rebate-title">
                                邀请奖励 •
                                <span class="tg-rebate-subtitle-inline">邀请好友订阅 即得20元奖励</span>
                            </span>
                        </div>

                        <!-- 加载中 -->
                        <div v-if="rebateLoading" class="tg-rebate-loading">
                            <van-loading type="spinner" size="24" color="#f59e0b" />
                            <span class="loading-text">加载中...</span>
                        </div>

                        <!-- 加载完成 -->
                        <template v-else>
                            <!-- 金额展示区域 -->
                            <div class="tg-rebate-amount-section">
                                <div class="tg-rebate-amount-main">
                                    <div class="tg-rebate-amount-label">可提现金额</div>
                                    <div class="tg-rebate-amount-value">
                                        <span class="amount-symbol">¥</span>
                                        <span class="amount-number">{{ rebateStats.withdrawable }}</span>
                                    </div>
                                </div>
                                <div class="tg-rebate-amount-divider"></div>
                                <div class="tg-rebate-amount-sub">
                                    <div class="tg-rebate-sub-item">
                                        <span class="sub-label">累计奖励</span>
                                        <span class="sub-value">¥{{ rebateStats.totalRebate }}</span>
                                    </div>
                                    <div class="tg-rebate-sub-item">
                                        <span class="sub-label">已提现</span>
                                        <span class="sub-value">¥{{ rebateStats.completedWithdraw }}</span>
                                    </div>
                                    <div class="tg-rebate-sub-item" v-if="rebateStats.pendingWithdraw > 0">
                                        <span class="sub-label">提现中</span>
                                        <span class="sub-value pending">¥{{ rebateStats.pendingWithdraw }}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- 提现按钮 -->
                            <button
                                    class="tg-rebate-withdraw-btn"
                                    :class="{
                            'active': rebateStats.withdrawable >= rebateStats.minWithdraw && rebateStats.pendingWithdraw <= 0,
                            'pending': rebateStats.pendingWithdraw > 0,
                            'disabled': rebateStats.withdrawable <= 0 || (rebateStats.withdrawable > 0 && rebateStats.withdrawable < rebateStats.minWithdraw && rebateStats.pendingWithdraw <= 0)
                            }"
                                    @click="onWithdrawClick"
                            >
                                <van-icon name="balance-pay" size="14" />
                                <span>{{ withdrawBtnText }}</span>
                            </button>

                            <!-- 提示 -->
                            <div class="tg-rebate-hint">
                                <van-icon name="info-o" size="12" color="#f59e0b" />
                                <span>复制上边的邀请链接发给好友<br>好友安装并订阅时长 您即可获得20元奖励<br>满40元可随时提现 客服24小时内处理</span>
                            </div>
                        </template>
                    </div>

                    <!-- 分隔线 -->
                    <div class="tg-rebate-center-divider"></div>

                    <!-- 下部：奖励统计 -->
                    <div class="tg-rebate-bottom">
                        <div class="tg-rebate-header-bottom">
                            <button class="tg-view-rebate-btn" @click="showRebateList">
                                <van-icon name="records" size="12" />
                                <span>查看奖励明细</span>
                            </button>
                        </div>

                        <!-- 统计数据 -->
                        <div class="tg-rebate-stats">
                            <div class="tg-rebate-stat-item">
                                <div class="tg-rebate-stat-value">{{ rebateStats.totalInvitees }}人</div>
                                <div class="tg-rebate-stat-header">
                                    <div class="tg-rebate-stat-icon">
                                        <svg viewBox="0 0 24 24" width="18" height="18" fill="#f59e0b">
                                            <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
                                        </svg>
                                    </div>
                                    <span class="tg-rebate-stat-label">已邀请</span>
                                </div>
                            </div>

                            <div class="tg-rebate-stat-divider"></div>

                            <div class="tg-rebate-stat-item">
                                <div class="tg-rebate-stat-value">{{ rebateStats.subscribedCount }}人</div>
                                <div class="tg-rebate-stat-header">
                                    <div class="tg-rebate-stat-icon">
                                        <svg viewBox="0 0 24 24" width="18" height="18" fill="#10b981">
                                            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                                        </svg>
                                    </div>
                                    <span class="tg-rebate-stat-label">已订阅</span>
                                </div>
                            </div>

                            <div class="tg-rebate-stat-divider"></div>

                            <div class="tg-rebate-stat-item">
                                <div class="tg-rebate-stat-value highlight">¥{{ rebateStats.totalRebate }}</div>
                                <div class="tg-rebate-stat-header">
                                    <div class="tg-rebate-stat-icon">
                                        <svg viewBox="0 0 24 24" width="18" height="18" fill="#ef4444">
                                            <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
                                        </svg>
                                    </div>
                                    <span class="tg-rebate-stat-label">累计奖励</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Tab 1: 增值服务 -->
        <div v-else-if="activeTab === 1" class="tg-section tg-tab-content">
            <div class="tg-card tg-value-added-card">
                <!-- 头部 -->
                <div class="tg-sub-header" style="justify-content: space-between;">
                    <div style="display: flex; align-items: center; gap: 8px;">
                        <div class="tg-sub-icon-solid">
                            <van-icon name="gem-o" size="14" color="#fff" />
                        </div>
                        <span class="tg-sub-title">增值服务 • 品质护航</span>
                    </div>
                </div>

                <!-- 分类卡片列表 -->
                <div class="tg-category-list">
                    <div
                            class="tg-category-card"
                            v-for="(category, cIdx) in categorizedServices"
                            :key="cIdx"
                            :style="{ background: category.bgColor }"
                    >
                        <!-- 分类标题 -->
                        <div class="tg-category-header">
                            <div class="tg-category-bar" :style="{ background: category.titleColor }"></div>
                            <van-icon :name="category.icon" size="14" :color="category.titleColor" />
                            <span class="tg-category-name" :style="{ color: category.titleColor }">
                                {{ category.name }}
                            </span>
                            <span class="tg-category-count">{{ category.services.length }}项</span>
                        </div>

                        <!-- 分类下的服务列表 -->
                        <div class="tg-category-services">
                            <div
                                    class="tg-service-item"
                                    :class="service.highlightEffect ? 'highlight-' + service.highlightEffect : ''"
                                    v-for="(service, sIdx) in category.services"
                                    :key="sIdx"
                                    @click="openServiceDetail(service)"
                            >
                                <div class="tg-service-icon" :style="{ background: service.bgColor }">
                                    <i v-if="service.icon && service.icon.startsWith('fa-')" :class="service.icon" style="color: #fff; font-size: 16px;"></i>
                                    <van-icon v-else :name="service.icon" size="14" color="#fff" />
                                </div>
                                <div class="tg-service-info">
                                    <div class="tg-service-title">
                                        <span class="tg-service-title-text">{{ service.title }}</span>
                                        <span v-if="service.tagIcon" class="tg-service-tag-icon">
                                            <van-icon :name="service.tagIcon" :color="getTagColor(service.tagIcon)" size="14" />
                                            <span v-if="service.tagText" class="tag-text">{{ service.tagText }}</span>
                                        </span>
                                    </div>
                                    <div class="tg-service-desc">{{ service.desc }}</div>
                                    <div class="tg-service-meta">
                                        <!-- 【修改】根据 priceType 显示不同标签 -->
                                        <template v-if="service.priceType === 'custom'">
                                            <!-- 自定义类型：显示自定义文字，紫色标签 -->
                                            <span class="tg-service-tag custom">{{ service.customLabel || '自定义' }}</span>
                                        </template>
                                        <template v-else-if="service.priceType === 'free'">
                                            <!-- 免费类型：显示免费，绿色标签 -->
                                            <span class="tg-service-tag free">免费</span>
                                        </template>
                                        <template v-else>
                                            <!-- 固定价格类型：原有逻辑 -->
                                            <span class="tg-service-price" v-if="service.price > 0 && !service.paid">¥{{ service.price }} 未解锁</span>
                                            <span class="tg-service-tag purchased" v-else-if="service.price > 0 && service.paid">¥{{ service.price }} 已解锁</span>
                                            <span class="tg-service-tag free" v-else>免费</span>
                                        </template>
                                        <span class="tg-service-views">
        <van-icon name="eye-o" size="10" />
        {{ service.realViews || service.users }}次查看
    </span>
                                    </div>
                                </div>
                                <div class="tg-service-arrow">
                                    <van-icon name="arrow" size="14" color="#c0c0c0" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ========================================== -->
        <!-- 板块五：版权信息 -->
        <!-- ========================================== -->
        <div class="tg-section tg-footer-section">
            <div class="tg-footer-content">
                <div class="tg-footer-version">Telegram中文版 Android v12.5.1</div>
                <div class="tg-footer-domain-row">
                    <span class="tg-footer-domain">www.Telegram.tw</span>
                </div>
            </div>
        </div>

        <!-- ========================================== -->
        <!-- 邀请记录弹窗（底部弹出） -->
        <!-- ========================================== -->
        <van-popup
                v-model="inviteHistoryShow"
                position="bottom"
                round
                :style="{ height: '99%' }"
                class="tg-invite-history-popup"
        >
            <!-- 头部 -->
            <div class="tg-invite-history-header">
                <div class="tg-invite-history-title">邀请记录</div>
                <van-icon name="cross" size="20" color="#999" @click="inviteHistoryShow = false" />
            </div>

            <!-- 有数据时显示滚动区域 -->
            <div
                    class="tg-invite-history-scroll"
                    ref="historyScroll"
                    v-if="inviteHistoryList.length > 0 || inviteHistoryLoading"
                    @scroll="onHistoryScroll"
            >
                <!-- 记录列表 -->
                <div
                        class="tg-invite-history-item"
                        v-for="(item, index) in inviteHistoryList"
                        :key="index"
                >
                    <div class="tg-invite-history-main">
                        <div class="tg-invite-history-user">
                            <van-icon name="user-o" size="14" color="#999" />
                            <span class="tg-invite-history-user-text">用户{{ item.inviteeMask }}</span>
                        </div>
                        <div class="tg-invite-history-time">
                            <van-icon name="clock-o" size="12" color="#999" />
                            <span>{{ item.inviteTime }}</span>
                        </div>
                    </div>
                    <div class="tg-invite-history-gift">
                        <span class="tg-invite-history-gift-label">获赠</span>
                        <span class="tg-invite-history-gift-days">+{{ item.giftDays }}天</span>
                    </div>
                </div>

                <!-- 加载更多提示 -->
                <div v-if="inviteHistoryLoading" class="tg-history-loading-more">
                    <van-loading type="spinner" size="20" color="#0ea5e9" />
                    <span>加载中...</span>
                </div>

                <!-- 没有更多数据 -->
                <div v-else-if="!inviteHistoryHasMore" class="tg-history-no-more">
                    <span>没有更多记录了</span>
                </div>
            </div>

            <!-- 空状态 -->
            <div class="tg-invite-history-empty" v-else>
                <van-icon name="records-o" size="48" color="#d1d5db" />
                <div class="tg-invite-history-empty-text">暂无邀请记录</div>
                <div class="tg-invite-history-empty-hint">快去邀请好友吧！</div>
            </div>
        </van-popup>

        <!-- ========================================== -->
        <!-- 【新增】奖励明细弹窗（底部弹出） -->
        <!-- ========================================== -->
        <van-popup
                v-model="rebateListShow"
                position="bottom"
                round
                :style="{ height: '99%' }"
                class="tg-rebate-list-popup"
        >
            <!-- 头部 -->
            <div class="tg-rebate-list-header">
                <div class="tg-rebate-list-title">奖励明细</div>
                <van-icon name="cross" size="20" color="#999" @click="rebateListShow = false" />
            </div>

            <!-- 有数据时显示滚动区域 -->
            <div
                    class="tg-rebate-list-scroll"
                    ref="rebateScroll"
                    v-if="rebateList.length > 0 || rebateListLoading"
            >
                <!-- 记录列表 -->
                <div
                        class="tg-rebate-list-item"
                        v-for="(item, index) in rebateList"
                        :key="index"
                        :class="{ 'subscribed': item.status >= 1 }"
                >
                    <div class="tg-rebate-list-main">
                        <div class="tg-rebate-list-user">
                            <van-icon name="user-o" size="14" color="#999" />
                            <span class="tg-rebate-list-user-text">{{ item.inviteeName }}</span>
                        </div>
                        <div class="tg-rebate-list-time">
                            <van-icon name="clock-o" size="12" color="#999" />
                            <span>{{ item.inviteTime }}</span>
                        </div>
                    </div>
                    <div class="tg-rebate-list-status">
                        <!-- 未订阅 -->
                        <template v-if="item.subStatus === '未订阅'">
                            <span class="status-badge unsubscribed">未订阅</span>
                        </template>
                        <!-- 已订阅 未提现 -->
                        <template v-else-if="item.subStatus === '已订阅' && item.withdrawStatus === '未提现'">
                            <div class="status-tags-row">
                                <span class="status-badge subscribed-text">已订阅</span>
                                <span class="status-badge withdraw-pending">未提现</span>
                            </div>
                        </template>
                        <!-- 已订阅 已提现 -->
                        <template v-else-if="item.subStatus === '已订阅' && item.withdrawStatus === '已提现'">
                            <div class="status-tags-row">
                                <span class="status-badge subscribed-text">已订阅</span>
                                <span class="status-badge withdraw-done">已提现</span>
                            </div>
                        </template>
                    </div>
                </div>
            </div>

            <!-- 空状态 -->
            <div class="tg-rebate-list-empty" v-else>
                <van-icon name="records-o" size="48" color="#d1d5db" />
                <div class="tg-rebate-list-empty-text">暂无奖励记录</div>
                <div class="tg-rebate-list-empty-hint">邀请好友订阅时长 即可获得奖励</div>
            </div>
        </van-popup>

        <!-- ========================================== -->
        <!-- 【修改】提现弹窗 - 支持成功状态显示 -->
        <!-- ========================================== -->
        <van-dialog
                v-model="withdrawShow"
                title="申请提现"
                :show-confirm-button="false"
                :show-cancel-button="false"
                class="tg-withdraw-dialog"
                @closed="closeWithdrawDialog"
        >
            <div class="tg-withdraw-content">

                <!-- ========== 成功状态 ========== -->
                <template v-if="withdrawSuccess">
                    <div class="tg-withdraw-success">
                        <div class="success-icon-wrap">
                            <van-icon name="success" size="48" color="#10b981" />
                        </div>
                        <div class="success-title">提现申请已提交</div>
                        <div class="success-amount">
                            <span class="success-amount-label">提现金额</span>
                            <span class="success-amount-value">¥{{ withdrawSuccessData.amount || withdrawAmount }}</span>
                        </div>
                        <div class="success-address">
                            <span class="success-address-label">USDT-TRC20 地址</span>
                            <span class="success-address-value">{{ withdrawAddress }}</span>
                        </div>
                        <div class="success-tips">
                            <van-icon name="clock-o" size="14" color="#f59e0b" />
                            <span>客服将在24小时内处理您的提现申请</span>
                        </div>
                        <div class="success-notice">
                            <van-icon name="info-o" size="12" color="#9ca3af" />
                            <span>请确保地址正确，转错无法找回</span>
                        </div>
                        <button class="tg-withdraw-btn-done" @click="closeWithdrawDialog">
                            我知道了
                        </button>
                    </div>
                </template>

                <!-- ========== 表单状态（默认） ========== -->
                <template v-else>
                    <!-- 可提现金额 -->
                    <div class="tg-withdraw-balance">
                        <span class="balance-label">可提现金额</span>
                        <span class="balance-value">¥{{ rebateStats.withdrawable }}</span>
                    </div>

                    <!-- 提现金额输入 -->
                    <div class="tg-withdraw-input-group">
                        <label class="input-label">提现金额</label>
                        <div class="input-wrapper">
                            <span class="input-symbol">¥</span>
                            <input
                                    type="number"
                                    v-model="withdrawAmount"
                                    class="withdraw-input"
                                    placeholder="请输入提现金额"
                                    :max="rebateStats.withdrawable"
                                    min="20"
                                    step="20"
                            />
                            <button class="input-all-btn" @click="setMaxWithdraw">全部</button>
                        </div>
                        <span class="input-hint">最小提现金额 ¥40，必须是20元的整数倍</span>
                    </div>

                    <!-- USDT地址输入 -->
                    <div class="tg-withdraw-input-group">
                        <label class="input-label">USDT-TRC20 地址</label>
                        <div class="input-wrapper address">
                            <input
                                    type="text"
                                    v-model="withdrawAddress"
                                    class="withdraw-input address"
                                    placeholder="请输入以T开头的34位地址"
                                    maxlength="34"
                            />
                        </div>
                    </div>

                    <!-- 温馨提示 -->
                    <div class="tg-withdraw-tips">
                        <div class="tips-title">
                            <van-icon name="warning-o" size="12" color="#f59e0b" />
                            <span>温馨提示</span>
                        </div>
                        <div class="tips-content">
                            <p>1. 请确保USDT-TRC20地址正确，转错无法找回。</p>
                            <p>2. 最小提现金额为 ¥20，且必须是20元的整倍数。</p>
                            <p>3. 客服将在24小时内处理您的提现申请。</p>
                        </div>
                    </div>

                    <!-- 自定义底部按钮 -->
                    <div class="tg-withdraw-footer">
                        <button class="tg-withdraw-btn-cancel" @click="closeWithdrawDialog">取消</button>
                        <button
                                class="tg-withdraw-btn-submit"
                                @click="submitWithdraw"
                                :disabled="withdrawSubmitting"
                        >
                            <van-loading v-if="withdrawSubmitting" type="spinner" size="14" color="#fff" />
                            <span v-else>确认提现</span>
                        </button>
                    </div>
                </template>
            </div>
        </van-dialog>

        <!-- ========================================== -->
        <!-- 增值服务详情弹窗 -->
        <!-- ========================================== -->
        <van-popup
                v-model="serviceDetailShow"
                position="bottom"
                round
                :style="{ height: '99%' }"
                class="tg-service-detail-popup"
        >
            <!-- 头部 -->
            <div class="tg-service-detail-header">
                <div class="tg-service-detail-icon" :style="{ background: currentService.bgColor }">
                    <i v-if="currentService.icon && currentService.icon.startsWith('fa-')" :class="currentService.icon" style="color: #fff; font-size: 20px;"></i>
                    <van-icon v-else :name="currentService.icon" size="20" color="#fff" />
                </div>
                <div class="tg-service-detail-title">{{ currentService.title }}</div>
                <van-icon name="cross" size="20" color="#999" @click="serviceDetailShow = false" />
            </div>

            <!-- 内容区 -->
            <div class="tg-service-detail-body">
                <!-- 免费服务 - 直接显示内容 -->
                <template v-if="currentService.price === 0">
                    <div class="tg-service-detail-content" v-html="currentService.detailContent || '暂无详细内容'"></div>
                </template>

                <!-- 收费服务 - 未付费显示购买界面 -->
                <template v-else-if="!currentService.paid">
                    <!-- 服务简介 + 购买提醒 -->
                    <div class="tg-service-info-card-v2">
                        <div class="service-info-left-bar"></div>
                        <div class="service-info-content-v2">
                            <div class="service-info-desc-v2">{{ currentService.desc || '解锁后即可查看详细内容和使用此服务' }}</div>
                            <div class="service-info-badge-v2">
                                <van-icon name="lock" size="10" color="#fff" />
                                <span>您即将解锁此服务</span>
                            </div>
                        </div>
                    </div>

                    <!-- 支付方式选择 -->
                    <div class="tg-service-pay-channel-section-v2">
                        <div class="tg-service-pay-channel-title-v2">选择支付方式</div>

                        <!-- 支付宝 -->
                        <div
                                class="tg-service-pay-channel-item-v2"
                                :class="{ active: servicePayChannel === 'alipay' }"
                                @click="servicePayChannel = 'alipay'"
                        >
                            <div class="tg-service-pay-channel-content-v2">
                                <van-radio name="alipay" icon-size="16px" :value="servicePayChannel" />
                                <div class="pay-channel-info-v2">
                                    <span class="tg-service-pay-channel-name-v2">支付宝</span>
                                    <span class="pay-channel-tip-v2">推荐，秒到账</span>
                                </div>
                                <van-image width="2.2rem" height="1.4rem" fit="cover" :src="require('../assets/alipay.svg')" />
                            </div>
                            <div class="pay-channel-active-bar-v2" v-if="servicePayChannel === 'alipay'"></div>
                        </div>

                        <div class="tg-service-pay-channel-divider-v2"></div>

                        <!-- 银行卡/信用卡 -->
                        <div
                                class="tg-service-pay-channel-item-v2"
                                :class="{ active: servicePayChannel === 'card' }"
                                @click="servicePayChannel = 'card'"
                        >
                            <div class="tg-service-pay-channel-content-v2">
                                <van-radio name="card" icon-size="16px" :value="servicePayChannel" />
                                <div class="pay-channel-info-v2">
                                    <span class="tg-service-pay-channel-name-v2">银行卡 信用卡</span>
                                    <span class="pay-channel-tip-v2">支持 Visa / MasterCard / 银联</span>
                                </div>
                                <div class="tg-service-pay-cards-inline-v2">
                                    <van-image width="1.6rem" height="1rem" fit="cover" :src="require('../assets/unionpay.svg')" />
                                    <van-image width="1.6rem" height="1rem" fit="cover" :src="require('../assets/visa.svg')" />
                                    <van-image width="1.6rem" height="1rem" fit="cover" :src="require('../assets/mastercard.svg')" />
                                    <van-image width="1.6rem" height="1rem" fit="cover" :src="require('../assets/jcb.svg')" />
                                    <van-image width="1.6rem" height="1rem" fit="cover" :src="require('../assets/amex.svg')" />
                                </div>
                            </div>
                            <div class="pay-channel-active-bar-v2" v-if="servicePayChannel === 'card'"></div>
                        </div>

                        <div class="tg-service-pay-channel-divider-v2"></div>

                        <!-- USDT -->
                        <div
                                class="tg-service-pay-channel-item-v2"
                                :class="{ active: servicePayChannel === 'usdt' }"
                                @click="servicePayChannel = 'usdt'"
                        >
                            <div class="tg-service-pay-channel-content-v2">
                                <van-radio name="usdt" icon-size="16px" :value="servicePayChannel" />
                                <div class="pay-channel-info-v2">
                                    <span class="tg-service-pay-channel-name-v2">USDT (TRC20)</span>
                                    <span class="pay-channel-tip-v2">区块链支付，匿名安全</span>
                                </div>
                                <van-image width="22px" height="22px" fit="cover" :src="require('../assets/usdt.svg')" />
                            </div>
                            <div class="pay-channel-active-bar-v2" v-if="servicePayChannel === 'usdt'"></div>
                        </div>

                        <div class="tg-service-pay-channel-divider-v2"></div>

                        <!-- TRX -->
                        <div
                                class="tg-service-pay-channel-item-v2"
                                :class="{ active: servicePayChannel === 'trx' }"
                                @click="servicePayChannel = 'trx'"
                        >
                            <div class="tg-service-pay-channel-content-v2">
                                <van-radio name="trx" icon-size="16px" :value="servicePayChannel" />
                                <div class="pay-channel-info-v2">
                                    <span class="tg-service-pay-channel-name-v2">TRX</span>
                                    <span class="pay-channel-tip-v2">波场网络，低手续费</span>
                                </div>
                                <van-image width="22px" height="22px" fit="cover" :src="require('../assets/trx.svg')" />
                            </div>
                            <div class="pay-channel-active-bar-v2" v-if="servicePayChannel === 'trx'"></div>
                        </div>
                    </div>

                    <!-- 支付卡片 -->
                    <div class="tg-service-pay-card-v2">
                        <div class="tg-service-pay-price-v2">
                            <span class="pay-label-v2">解锁此服务</span>
                            <span class="pay-amount-v2">¥{{ currentService.price }}</span>
                        </div>

                        <!-- 微光按钮 -->
                        <button class="tg-service-pay-btn-v2 shimmer-btn" @click="payForService(currentService)">
                            <van-icon name="balance-pay" size="16" />
                            <span>立即支付 ¥{{ currentService.price }} 解锁</span>
                            <div class="shimmer-effect-v2"></div>
                        </button>
                    </div>
                </template>

                <!-- 收费服务 - 已付费显示内容 -->
                <template v-else>
                    <div class="tg-service-detail-content" v-html="currentService.detailContent || '暂无详细内容'"></div>
                </template>
            </div>
        </van-popup>

        <!-- ========================================== -->
        <!-- 支付弹窗：支付宝 -->
        <!-- ========================================== -->
        <van-dialog v-model="qr_show" show-cancel-button confirm-button-text="支付完成" @confirm="_confirm" class="tg-pay-dialog">
            <template #title>
                <div class="tg-dialog-header">支付宝扫码支付</div>
            </template>
            <div class="tg-qr-wrapper">
                <div class="tg-qr-box">
                    <van-image :src="qrcode" width="180" height="180">
                        <template v-slot:loading>
                            <van-loading type="spinner" size="32" color="#24A1DE" />
                        </template>
                    </van-image>
                </div>
                <div class="tg-qr-hint">请使用支付宝完成支付</div>
            </div>
        </van-dialog>

        <!-- ========================================== -->
        <!-- 支付弹窗：虚拟币支付 -->
        <!-- ========================================== -->
        <van-dialog
                v-model="crypto_show"
                :show-confirm-button="false"
                :show-cancel-button="true"
                cancel-button-text="关闭"
                class="tg-pay-dialog crypto-dialog"
                @closed="onCryptoDialogClosed"
        >
            <template #title>
                <div class="tg-dialog-header">
                    <span v-if="currentOrderType === 'value_added' && servicePayChannel === 'usdt'">USDT (TRC20) 支付</span>
                    <span v-else-if="currentOrderType === 'value_added' && servicePayChannel === 'trx'">TRX 支付</span>
                    <span v-else-if="payChannel === 'usdt'">USDT (TRC20) 支付</span>
                    <span v-else-if="payChannel === 'trx'">TRX 支付</span>
                    <span v-else>虚拟币支付</span>
                </div>
            </template>
            <div class="tg-crypto-wrapper">
                <div class="crypto-pay-card">
                    <div class="crypto-pay-amount">
                        <div class="crypto-amount-label">支付金额</div>
                        <div class="crypto-amount-value">
                            <span class="amount-number">{{ cryptoAmount }}</span>
                            <span class="amount-unit">{{ payChannel === 'usdt' ? 'USDT' : 'TRX' }}</span>
                        </div>
                        <div class="crypto-amount-cny">
                            ≈ ¥{{ currentOrderType === 'value_added' ? (currentService.price || 0) : (currentPackage ? currentPackage.total_amount : 0) }}
                        </div>
                    </div>

                    <div class="crypto-countdown" v-if="crypto_show && cryptoStatus !== 'failed' && cryptoStatus !== 'success'">
                        <van-icon name="clock-o" size="14" color="#ef4444" />
                        <span>支付剩余时间 {{ cryptoCountdownText }}</span>
                    </div>
                </div>

                <div v-if="cryptoQrLoading" class="crypto-loading-section">
                    <van-loading type="spinner" size="40" color="#24A1DE" />
                    <div class="crypto-loading-text">正在获取收款地址...</div>
                </div>

                <div v-else-if="cryptoStatus === 'failed'" class="crypto-error-section">
                    <van-icon name="warning-o" size="48" color="#ef4444" />
                    <div class="crypto-error-text">{{ cryptoErrorMsg || '获取支付地址失败' }}</div>
                    <button class="crypto-retry-btn" @click="retryCryptoPayment">
                        <van-icon name="replay" size="16" />
                        <span>重新获取</span>
                    </button>
                </div>

                <template v-else>
                    <div class="crypto-qr-section">
                        <div class="crypto-qr-box">
                            <img :src="cryptoQrCode" class="crypto-qr-img" alt="支付二维码" v-if="cryptoQrCode" />
                            <div class="crypto-network-badge">TRC20</div>
                        </div>
                        <div class="crypto-qr-hint">请使用 {{ payChannel === 'usdt' ? 'USDT' : 'TRX' }} 钱包扫码支付</div>
                    </div>

                    <div class="crypto-address-section">
                        <div class="crypto-address-label">收款地址</div>
                        <div class="crypto-address-capsule">
                            <div class="crypto-address-pill">
                                <div class="crypto-address-text">{{ cryptoAddress }}</div>
                            </div>
                            <button class="crypto-copy-capsule" @click="copyCryptoAddress">
                                <van-icon name="description" size="14" />
                                <span>复制地址</span>
                            </button>
                        </div>
                    </div>

                    <div class="crypto-status-box" :class="cryptoStatus" v-if="cryptoStatus !== 'waiting'">
                        <van-icon
                                :name="cryptoStatusIcon"
                                size="20"
                                :color="cryptoStatusColor"
                        />
                        <span>{{ cryptoStatusText }}</span>
                    </div>
                </template>

                <div class="crypto-warning-box">
                    <div class="crypto-warning-text">
                        <p>1. 请确保使用 <strong>TRON (TRC20)</strong> 网络</p>
                        <p>2. 请确保支付金额准确 少付或多付将无法自动订阅</p>
                        <p>3. 支付过程中请勿关闭弹窗 支付成功会自动关闭并订阅</p>
                    </div>
                </div>
            </div>
        </van-dialog>

        <!-- ========================================== -->
        <!-- 更新提醒条 -->
        <!-- ========================================== -->
        <div v-if="showUpdateBar" class="tg-update-bar" @click="handleUpdateClick">
            <div v-if="!isDownloading && !downloadComplete" class="tg-update-content">
                <div class="tg-update-icon">
                    <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                        <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
                    </svg>
                </div>
                <span class="tg-update-text">更新Telegram中文版</span>
            </div>
            <div v-else-if="isDownloading" class="tg-update-content">
                <van-loading type="spinner" size="20" color="#fff" />
                <span class="tg-update-text">下载中 {{ downloadProgress }}%</span>
            </div>
            <div v-else-if="downloadComplete" class="tg-update-content">
                <div class="tg-update-icon" style="background: #fff;">
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="#10b981">
                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                    </svg>
                </div>
                <span class="tg-update-text">立即安装</span>
            </div>
        </div>
    </van-pull-refresh>
</template>
<script>
    import { Toast, ActionSheet, Dialog } from 'vant'
    import QRCode from 'qrcode'

    const TG_AVATAR_COLORS = [
        '#ff885e', '#ff516a', '#ff6b6b', '#ffa85c', '#ffcd6a',
        '#a0de6e', '#54cb68', '#28c9b7', '#2dc9f5', '#5ca8fa',
        '#7a95ff', '#a481ff', '#d396ff', '#ffa8a8', '#7ad39e',
        '#59d1c6', '#7db8ff', '#9db8ff', '#c49dff', '#ff8a8a',
    ];

    const UPDATE_CONFIG = {
        latestVersion: '12.5.1',
        downloadUrl: 'https://www.telegram.tw/android.apk',
    };

    // 邀请相关API基础地址
    const INVITE_API = 'https://invite.telezh.net/api';

    // 预绑定API地址
    const PREBIND_API = 'https://my.telegram.tw/api';

    // 增值服务API地址
    const SVC_API = 'https://serve.telezh.net/api';

    export default {
        name: 'HelloWorld',
        components: {
            [ActionSheet.name]: ActionSheet,
            [Dialog.Component.name]: Dialog.Component,
        },
        data() {
            return {
                isLoading: false,
                Imei: null,
                name: null,
                phone: null,
                username: '',
                avatarUrl: '',
                end_Time: null,
                status: null,
                qrcode: null,
                qr_show: false,
                order_sn: null,
                renderKey: 0,
                payChannel: 'alipay',
                crypto_show: false,
                cryptoAmount: '0.00',
                cryptoAddress: '',
                cryptoQrCode: '',
                cryptoQrLoading: false,
                cryptoOrderSn: '',
                cryptoStatus: 'waiting',
                cryptoErrorMsg: '',
                cryptoTimer: null,
                cryptoCountdown: 900,
                cryptoCountdownTimer: null,
                currentPackage: null,
                autoBindAttempted: false,
                hasParent: false,
                canBind: true,
                parentInviteCode: '',
                inviteCode: '',
                // 增值服务相关
                valueAddedServices: [],
                categorizedServices: [],
                serviceDetailShow: false,
                currentService: {},
                currentOrderType: 'subscription',
                currentServiceId: 0,
                servicePayChannel: 'alipay',
                // 【新增】提现提交状态
                withdrawSubmitting: false,
                // 【新增】提现成功状态
                withdrawSuccess: false,
                withdrawSuccessData: null,
                // 会员套餐
                packages: [
                    { buy_num: 1, total_amount: 38 },
                    { buy_num: 3, total_amount: 98 },
                    { buy_num: 6, total_amount: 168 },
                    { buy_num: 12, total_amount: 298 }
                ],
                isActive: false,
                shareSheetShow: false,
                shareUrl: 'www.telegram.tw',
                shareText: 'Telegram中文版 - 下载网址',
                showUpdateBar: false,
                isDownloading: false,
                downloadComplete: false,
                downloadProgress: 0,
                updateInstalled: false,
                hasNativeSupport: false,
                currentVersion: null,
                crispInitialized: false,
                chatOpened: false,
                savedOrder: null,
                isCreatingOrder: false,
                pollingOrderSn: null,
                referralLoading: true,
                inviteStats: {
                    totalInvites: 0,
                    monthInvites: 0,
                    totalGiftDays: 0
                },
                inviteLink: '',
                inviteCopied: false,
                crispTimer: null,
                inviteHistoryShow: false,
                inviteHistoryList: [],
                inviteHistoryLoading: false,
                inviteHistoryPage: 1,
                inviteHistoryPageSize: 20,
                inviteHistoryHasMore: true,
                activeTab: 0,
                indicatorStyle: {
                    transform: 'translateX(0px)',
                    width: '33.333%'
                },
                // 【新增】邀请奖励相关
                rebateLoading: true,
                rebateStats: {
                    totalRebate: 0,
                    withdrawable: 0,        // 这个已经是20的倍数（后端计算）
                    pendingWithdraw: 0,
                    completedWithdraw: 0,
                    totalInvitees: 0,
                    subscribedCount: 0,
                    hasPending: false,
                    minWithdraw: 40
                },
                rebateListShow: false,
                rebateList: [],
                rebateListLoading: false,
                withdrawShow: false,
                withdrawAmount: '',
                withdrawAddress: '',
            }
        },
        computed: {
            displayName() {
                return this.name || 'Telegram User'
            },
            formattedPhone() {
                if (!this.phone) return ''
                const clean = String(this.phone).replace(/\D/g, '')
                if (clean.length > 0) {
                    return '+' + clean.slice(0, 2) + clean.slice(2)
                }
                return this.phone
            },
            hasUsername() {
                return this.username && this.username.trim().length > 0
            },
            currentIcon() {
                return this.payChannel === 'alipay'
                    ? require('../assets/zhipay.jpg')
                    : require('../assets/cardpay.png')
            },
            cryptoCountdownText() {
                const minutes = Math.floor(this.cryptoCountdown / 60)
                const seconds = this.cryptoCountdown % 60
                return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
            },
            cryptoStatusIcon() {
                const icons = {
                    waiting: 'clock-o',
                    pending: 'clock-o',
                    confirming: 'clock-o',
                    success: 'checked',
                    failed: 'clear'
                }
                return icons[this.cryptoStatus] || 'clock-o'
            },
            cryptoStatusColor() {
                const colors = {
                    waiting: '#9ca3af',
                    pending: '#f59e0b',
                    confirming: '#3b82f6',
                    success: '#10b981',
                    failed: '#ef4444'
                }
                return colors[this.cryptoStatus] || '#9ca3af'
            },
            cryptoStatusText() {
                const texts = {
                    waiting: '等待支付...',
                    pending: '已检测到交易，等待确认...',
                    confirming: '确认中...',
                    success: '支付成功！',
                    failed: '支付失败/超时'
                }
                return texts[this.cryptoStatus] || '等待支付...'
            },
            // ==========================================
// 【修改】提现按钮文字 - 调整判断优先级
// ==========================================
            withdrawBtnText() {
                // 优先级1：有待处理提现（最高优先级，不管可提现金额多少）
                if (this.rebateStats.pendingWithdraw > 0) {
                    return '提现处理中';
                }

                // 优先级2：可提现金额满足最低要求
                if (this.rebateStats.withdrawable >= this.rebateStats.minWithdraw) {
                    return '立即提现';
                }

                // 优先级3：有可提现金额但不足最低要求
                if (this.rebateStats.withdrawable > 0) {
                    return '可提现金额不足';
                }

                // 优先级4：没有任何可提现金额
                return '暂无可提现';
            }
        },
        watch: {
            crypto_show(newVal) {
                if (newVal) {
                    this.hideCrispForDialog()
                } else {
                    this.showCrispForDialog()
                }
            },
        },

        mounted() {
            window.ftest = this.ftest
            window.onDownloadComplete = this.onDownloadComplete.bind(this)
            window.onDownloadProgress = this.onDownloadProgress.bind(this)

            window.onInstallStarted = this.onInstallStarted.bind(this);
            window.onInstallFailed = this.onInstallFailed.bind(this);
            window.onInstallPermissionGranted = this.onInstallPermissionGranted.bind(this);

            this.loadCrisp()
            this.initCrispListener()

            setTimeout(() => this.forceFixCrisp(), 1000)

            this.$nextTick(async () => {
                await this.initData()
                this.checkPaymentReturn()
                this.checkUpdate()
                this.cleanupProcessedOrders()
                this.updateIndicator()
                await this.loadServices()
            })

            window.addEventListener('resize', this.updateIndicator)
            window.stopCrispTimer = this.stopCrispTimer
        },

        beforeDestroy() {
            if (this.crispTimer) {
                clearInterval(this.crispTimer)
                this.crispTimer = null
            }
            if (this.cryptoCountdownTimer) {
                clearInterval(this.cryptoCountdownTimer)
                this.cryptoCountdownTimer = null
            }
            if (this._crispObserver) {
                this._crispObserver.disconnect()
            }
            const style = document.getElementById('crisp-position-fix')
            if (style) style.remove()
            window.removeEventListener('resize', this.updateIndicator)
        },
        methods: {
            // 切换Tab
            switchTab(index) {
                if (this.activeTab === index) return
                this.activeTab = index
                this.updateIndicator()

                if (index === 1) {
                    this.loadServices().then(() => {
                        console.log('【switchTab】loadServices 完成，服务数量:', this.valueAddedServices.length)
                    })
                }
            },

            // ==========================================
            // 【新增】邀请奖励相关方法
            // ==========================================

            // 加载奖励统计
            async loadRebateStats() {
                if (!this.Imei || this.Imei.length < 10) {
                    setTimeout(() => this.loadRebateStats(), 500)
                    return
                }

                this.rebateLoading = true

                try {
                    const res = await this.$axios.get(`${INVITE_API}/rebate/stats.php?imei=${this.Imei}`)

                    if (res.data.code === 200) {
                        const data = res.data.data
                        this.rebateStats = {
                            totalRebate: data.totalRebate || 0,
                            withdrawable: data.withdrawable || 0,
                            pendingWithdraw: data.pendingWithdraw || 0,
                            completedWithdraw: data.completedWithdraw || 0,
                            totalInvitees: data.totalInvitees || 0,
                            subscribedCount: data.subscribedCount || 0,
                            hasPending: data.hasPending || false,
                            minWithdraw: data.minWithdraw || 20
                        }
                    }
                } catch (e) {
                    console.error('获取奖励统计失败:', e)
                } finally {
                    this.rebateLoading = false
                }
            },

            // 显示奖励明细弹窗
            showRebateList() {
                this.rebateListShow = true
                this.rebateList = []       // 清空列表
                this.loadRebateList()       // 直接加载所有数据
            },

            // 加载奖励列表
            async loadRebateList() {
                if (!this.Imei || this.Imei.length < 10) {
                    Toast({ message: '设备信息获取中，请稍候', position: 'top' })
                    return
                }

                // 防止重复加载
                if (this.rebateListLoading) {
                    return
                }

                this.rebateListLoading = true

                try {
                    // 不需要传 page 和 pageSize，后端返回所有数据
                    const res = await this.$axios.get(
                        `${INVITE_API}/rebate/list.php?imei=${this.Imei}`
                    )

                    if (res.data.code === 200) {
                        const data = res.data.data
                        // 直接赋值，不是追加
                        this.rebateList = data.list || []
                    } else {
                        Toast({ message: res.data.msg || '获取奖励明细失败', position: 'top' })
                    }
                } catch (e) {
                    console.error('获取奖励明细失败:', e)
                    Toast({ message: '网络错误，请稍候再试', position: 'top' })
                } finally {
                    this.rebateListLoading = false
                }
            },

            // ==========================================
            // 【修改】滚动加载 - 不分页了，不需要加载更多
            // ==========================================
            onRebateScroll(e) {
                // 不分页了，不需要滚动加载
                // 保留空方法，防止模板中绑定的事件报错
            },

            // 设置最大提现金额（20的整数倍）
            setMaxWithdraw() {
                const maxAmount = Math.floor(this.rebateStats.withdrawable / 20) * 20;
                this.withdrawAmount = maxAmount > 0 ? maxAmount : '';
            },

            // 【修改】关闭提现弹窗并重置所有状态
            closeWithdrawDialog() {
                this.withdrawShow = false;
                this.withdrawAmount = '';
                this.withdrawAddress = '';
                this.withdrawSuccess = false;
                this.withdrawSuccessData = null;
            },

            // ==========================================
            // 【修改】提现按钮点击 - 调整判断优先级
            // ==========================================
            onWithdrawClick() {
                // 优先级1：有待处理提现
                if (this.rebateStats.pendingWithdraw > 0) {
                    Toast({ message: '您有提现申请正在处理中，请耐心等待', position: 'top', duration: 3000 });
                    return;
                }

                // 优先级2：可提现金额满足最低要求
                if (this.rebateStats.withdrawable >= this.rebateStats.minWithdraw) {
                    const maxAmount = Math.floor(this.rebateStats.withdrawable / 20) * 20;
                    this.withdrawAmount = maxAmount;
                    this.withdrawAddress = '';
                    this.withdrawSuccess = false;  // 确保重置成功状态
                    this.withdrawShow = true;
                    return;
                }

                // 优先级3：有可提现金额但不足最低要求
                if (this.rebateStats.withdrawable > 0) {
                    Toast({ message: `满${this.rebateStats.minWithdraw}元可提现，当前可提现¥${this.rebateStats.withdrawable}`, position: 'top', duration: 3000 });
                    return;
                }

                // 优先级4：没有任何可提现金额
                Toast({ message: '暂无可提现金额 邀请好友订阅时长 获得奖励', position: 'top', duration: 3000 });
            },

            // 提交提现申请
            async submitWithdraw() {
                if (this.withdrawSubmitting) return;

                const amount = parseFloat(this.withdrawAmount);

                if (!this.withdrawAmount || this.withdrawAmount === '' || isNaN(amount)) {
                    Toast({ message: '请输入有效的提现金额', position: 'top', duration: 3000 });
                    return;
                }

                if (amount < 40) {
                    Toast({ message: '最小提现金额为40元', position: 'top', duration: 3000 });
                    return;
                }

                if (amount % 20 !== 0) {
                    Toast({ message: '提现金额必须是20元的整数倍，如20、40、60...', position: 'top', duration: 3000 });
                    return;
                }

                if (amount > this.rebateStats.withdrawable) {
                    Toast({ message: `提现金额超出可提现余额，当前可提现¥${this.rebateStats.withdrawable}`, position: 'top', duration: 3000 });
                    return;
                }

                if (!this.withdrawAddress || this.withdrawAddress.trim() === '') {
                    Toast({ message: '请输入USDT-TRC20地址', position: 'top', duration: 3000 });
                    return;
                }

                const address = this.withdrawAddress.trim();
                if (!/^T[a-zA-Z0-9]{33}$/.test(address)) {
                    Toast({ message: 'USDT-TRC20地址格式错误，请以T开头的34位地址', position: 'top', duration: 3000 });
                    return;
                }

                this.withdrawSubmitting = true;

                try {
                    Toast({ message: '正在提交...', position: 'top', duration: 0 });

                    const res = await this.$axios.post(
                        `${INVITE_API}/rebate/withdraw.php`,
                        this.$qs.stringify({
                            imei: this.Imei,
                            amount: amount,
                            address: address
                        }),
                        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                    );

                    Toast.clear();

                    if (res.data.code === 200) {
                        // 【修改】不立即关闭弹窗，而是显示成功状态
                        this.withdrawSuccess = true;
                        this.withdrawSuccessData = res.data.data || {};

                        // 刷新统计数据
                        this.loadRebateStats();
                    } else {
                        Toast({ message: res.data.msg || '提现失败', position: 'top', duration: 3000 });
                    }
                } catch (e) {
                    Toast.clear();
                    console.error('提现失败:', e);
                    Toast({ message: '网络错误，请稍候再试', position: 'top', duration: 3000 });
                } finally {
                    this.withdrawSubmitting = false;
                }
            },

            // 触发邀请返现
            async triggerRebate() {
                try {
                    const res = await this.$axios.post(
                        `${INVITE_API}/rebate/trigger.php`,
                        this.$qs.stringify({
                            imei: this.Imei,
                            order_sn: this.order_sn || this.cryptoOrderSn || ''
                        }),
                        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                    )

                    if (res.data.code === 200 && res.data.data.rebate > 0) {
                        // 刷新返现统计
                        this.loadRebateStats()
                    }
                } catch (e) {
                    console.error('【triggerRebate】失败:', e)
                }
            },

            // ==========================================
            // 增值服务相关方法
            // ==========================================

            getTagColor(icon) {
                const colors = {
                    fire: '#ff4d4f',
                    hot: '#ff7a45',
                    new: '#52c41a',
                    vip: '#722ed1',
                    star: '#fadb14',
                    crown: '#faad14',
                    rocket: '#ff6b6b',
                    lightning: '#fbbf24',
                    gift: '#ec4899',
                    heart: '#ef4444',
                    bell: '#f59e0b',
                    lock: '#8b5cf6',
                    diamond: '#0ea5e9',
                    trophy: '#f59e0b',
                    medal: '#f97316',
                    tag: '#10b981',
                    robot: '#6366f1',
                    android: '#3ddc84'
                };
                return colors[icon] || '#ff4d4f';
            },

            async loadServices() {
                try {
                    const imei = this.Imei || '';
                    const url = imei ? `${SVC_API}/list.php?imei=${imei}` : `${SVC_API}/list.php`;

                    console.log('【loadServices】请求 URL:', url)

                    const res = await this.$axios.get(url);

                    console.log('【loadServices】响应:', res.data)

                    if (res.data.code == 200) {
                        if (res.data.data && res.data.data.length > 0 && res.data.data[0].services) {
                            this.categorizedServices = res.data.data;
                            this.valueAddedServices = [];
                            res.data.data.forEach(cat => {
                                this.valueAddedServices.push(...cat.services);
                            });
                        } else {
                            this.valueAddedServices = res.data.data || [];
                            this.categorizedServices = [{
                                id: 0,
                                name: '全部服务',
                                icon: 'apps-o',
                                bgColor: 'linear-gradient(135deg, #f8fafc, #f1f5f9)',
                                titleColor: '#64748b',
                                services: this.valueAddedServices
                            }];
                        }
                        console.log('【loadServices】分类数量:', this.categorizedServices.length)
                    } else {
                        console.error('【loadServices】返回码错误:', res.data.code, res.data.msg)
                    }
                } catch (e) {
                    console.error('【loadServices】请求失败:', e)
                }
            },

            async openServiceDetail(service) {
                await this.incrementView(service.id);

                let paid = service.paid || false;
                if (!paid && service.price > 0 && this.Imei && this.Imei.length >= 10) {
                    try {
                        paid = await this.checkServicePaid(service.id);
                    } catch (e) {
                        console.error('检查服务状态失败:', e);
                        paid = false;
                    }
                }

                this.currentService = {
                    ...service,
                    paid: service.price === 0 ? true : paid
                };

                this.servicePayChannel = 'alipay';

                this.serviceDetailShow = true;
            },

            async incrementView(serviceId) {
                try {
                    const res = await this.$axios.post(
                        `${SVC_API}/view.php`,
                        this.$qs.stringify({ service_id: serviceId }),
                        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                    );
                    if (res.data.code === 200) {
                        const service = this.valueAddedServices.find(s => s.id === serviceId);
                        if (service) {
                            service.realViews = res.data.data.views;
                        }
                    }
                } catch (e) {
                    console.error('增加浏览次数失败:', e);
                }
            },

            async checkServicePaid(serviceId) {
                if (!this.Imei || this.Imei.length < 10) return false;
                try {
                    const res = await this.$axios.get(
                        `${SVC_API}/status.php?service_id=${serviceId}&imei=${this.Imei}`
                    );
                    if (res.data.code === 200) {
                        return res.data.data.paid;
                    }
                } catch (e) {
                    console.error('检查购买状态失败:', e);
                }
                return false;
            },

            async payForService(service) {
                if (!this.Imei || this.Imei.length < 10) {
                    Toast({ message: '设备信息获取失败，请重试', position: 'top' });
                    return;
                }

                const channel = this.servicePayChannel;

                if (channel === 'usdt' || channel === 'trx') {
                    await this.handleValueAddedCryptoPayment(service);
                } else if (channel === 'alipay' || channel === 'card') {
                    await this.handleValueAddedStripe(service);
                }
            },

            async handleValueAddedStripe(service) {
                Toast({ message: '正在创建订单...', position: 'top', duration: 0 });

                try {
                    const res = await this.$axios.post(
                        `${SVC_API}/stripe/create.php`,
                        this.$qs.stringify({
                            service_id: service.id,
                            service_title: service.title,
                            total_amount: service.price,
                            imei: this.Imei,
                            pay_channel: this.servicePayChannel
                        }),
                        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                    );

                    Toast.clear();

                    if (!res || !res.data) {
                        Toast({ message: '服务器响应异常', position: 'top' });
                        return;
                    }

                    if (res.data.code == 1 || res.data.code == 2) {
                        const data = res.data.data;

                        localStorage.setItem('pendingStripeOrder', JSON.stringify({
                            order_sn: data.order_sn,
                            service_id: service.id,
                            service: service,
                            activeTab: 1,
                            create_time: Date.now()
                        }));

                        this.currentService = { ...service, paid: false };
                        this.currentServiceId = service.id;
                        this.serviceDetailShow = true;

                        if (this.servicePayChannel === 'alipay') {
                            if (data.qrcode) {
                                this.qrcode = data.qrcode;
                                this.order_sn = data.order_sn;
                                this.qr_show = true;
                            } else {
                                Toast({ message: '二维码生成失败', position: 'top' });
                            }
                        } else {
                            window.location.href = data.pay_url;
                        }
                        return;

                    } else {
                        Toast({ message: res.data.msg || '创建订单失败', position: 'top' });
                    }

                } catch (e) {
                    console.error('Stripe支付失败:', e);
                    Toast({ message: '网络错误，请稍候再试', position: 'top' });
                }
            },

            async handleValueAddedCryptoPayment(service) {
                if (!this.Imei || this.Imei.length < 10) {
                    Toast({ message: '设备信息获取失败，请重试', position: 'top' });
                    return;
                }

                const cryptoType = this.servicePayChannel;

                const vaSavedKey = 'pendingVAOrder_' + service.id;
                const saved = localStorage.getItem(vaSavedKey);

                if (saved) {
                    const oldOrder = JSON.parse(saved);
                    const now = Math.floor(Date.now() / 1000);
                    if (now - oldOrder.create_time < 300) {
                        try {
                            const res = await this.$axios.post(
                                'https://crypto.telezh.net/check.php',
                                this.$qs.stringify({
                                    order_sn: oldOrder.order_sn,
                                    imei: this.Imei,
                                    order_type: 'value_added'
                                }),
                                { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                            );
                            if (res.data.status == 1 && res.data.data.pay_status == 0 && !res.data.data.expired) {
                                this.restoreCryptoOrder(oldOrder, service, 'value_added');
                                return;
                            }
                        } catch (e) {
                            console.error('恢复增值服务订单失败:', e);
                        }
                    }
                    localStorage.removeItem(vaSavedKey);
                }

                this.initCryptoDialog('value_added', service.id);

                try {
                    const res = await this.$axios.post(
                        'https://crypto.telezh.net/create.php',
                        this.$qs.stringify({
                            order_type: 'value_added',
                            service_id: service.id,
                            service_title: service.title,
                            total_amount: service.price,
                            crypto_type: cryptoType,
                            Imei: this.Imei
                        }),
                        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                    );

                    if (res.data.status == 1) {
                        this.cryptoAddress = res.data.data.address;
                        this.cryptoOrderSn = res.data.data.order_sn;
                        this.cryptoAmount = res.data.data.crypto_amount;

                        const orderInfo = {
                            order_sn: res.data.data.order_sn,
                            create_time: Math.floor(Date.now() / 1000),
                            crypto_type: cryptoType,
                            crypto_amount: res.data.data.crypto_amount,
                            address: res.data.data.address,
                            service_id: service.id,
                            total_amount: service.price,
                            imei: String(this.Imei || '').trim()
                        };
                        localStorage.setItem(vaSavedKey, JSON.stringify(orderInfo));

                        await this.generateCryptoQR(this.cryptoAddress, this.cryptoAmount, cryptoType);
                        this.cryptoQrLoading = false;
                        this.startCryptoPolling();
                        this.startCryptoCountdown();
                    } else {
                        this.handleCryptoError(res.data.msg || '创建订单失败');
                    }
                } catch (err) {
                    this.handleCryptoError('网络连接失败，请检查网络后重试');
                }
            },

            restoreCryptoOrder(oldOrder, pkg, orderType) {
                this.cryptoOrderSn = oldOrder.order_sn;
                this.cryptoAmount = oldOrder.crypto_amount;
                this.cryptoAddress = oldOrder.address || '';
                this.payChannel = oldOrder.crypto_type;
                this.currentPackage = pkg;
                this.currentOrderType = orderType;
                this.currentServiceId = oldOrder.service_id || 0;

                const elapsed = Math.floor(Date.now() / 1000) - oldOrder.create_time;
                this.cryptoCountdown = Math.max(900 - elapsed, 0);

                this.crypto_show = true;
                this.cryptoQrLoading = false;
                this.cryptoStatus = 'waiting';
                this.cryptoErrorMsg = '';

                this.generateCryptoQR(this.cryptoAddress, this.cryptoAmount, this.payChannel).then(() => {
                    this.startCryptoPolling();
                    this.startCryptoCountdown();
                });
            },

            initCryptoDialog(orderType, serviceId = 0) {
                this.cryptoAmount = '计算中...';
                this.crypto_show = true;
                this.cryptoQrLoading = true;
                this.cryptoStatus = 'waiting';
                this.cryptoCountdown = 900;
                this.cryptoAddress = '';
                this.cryptoQrCode = '';
                this.cryptoErrorMsg = '';
                this.currentOrderType = orderType;
                this.currentServiceId = serviceId;
                this.clearCryptoTimer();
                this.clearCryptoCountdownTimer();
            },

            handleCryptoError(msg) {
                this.cryptoQrLoading = false;
                this.cryptoStatus = 'failed';
                this.cryptoErrorMsg = this.escapeHtml(msg);
                this.releaseCreateLock();
                Toast({ message: this.cryptoErrorMsg, position: 'top', duration: 3000 });
            },

            // ==========================================
            // 原有会员充值方法
            // ==========================================

            async buy(pkg) {
                try {
                    localStorage.setItem('lastPayCh', this.payChannel)
                } catch (e) {}

                this.currentPackage = pkg

                if (this.payChannel === 'usdt' || this.payChannel === 'trx') {
                    this.handleCryptoPayment(pkg)
                    return
                }

                const tradeType = this.payChannel === 'alipay' ? 'Stripe_alipay' : 'bank_card'
                let hkdAmount

                if (tradeType === 'bank_card') {
                    const rate = await this.getRate()
                    const cnyToHkdRate = 1 / rate
                    hkdAmount = Math.round(pkg.total_amount * cnyToHkdRate * 100)
                } else {
                    const rate = await this.getRate()
                    const cnyToHkdRate = 1 / rate
                    hkdAmount = Math.round(pkg.total_amount * cnyToHkdRate * 100)
                }

                hkdAmount = Math.max(hkdAmount, 400)
                const returnUrl = `https://mine.telezh.net/?channel=${this.payChannel}`

                this.$axios.post(
                    'https://zhifu.telezh.net/charge/create',
                    this.$qs.stringify({
                        buy_num: pkg.buy_num,
                        total_amount: hkdAmount,
                        trade_type: tradeType,
                        callback_url: returnUrl,
                        Imei: this.Imei
                    }),
                    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                ).then(res => {
                    if (tradeType === 'bank_card') {
                        window.location.href = res.data.data.pay_url
                    } else {
                        this.qrcode = res.data.data.qrcode
                        this.order_sn = res.data.data.order_sn
                        this.qr_show = true
                    }
                }).catch(err => {
                    console.error('【支付】错误:', err)
                    Toast({ message: '网络错误！请稍候再试', position: 'top' })
                })
            },

            async handleCryptoPayment(pkg) {
                if (!this.Imei) {
                    Toast({ message: '无法获取设备信息，请重试', position: 'top' })
                    return
                }

                if (!this.acquireCreateLock()) {
                    Toast({ message: '正在处理中，请稍候', position: 'top' })
                    return
                }

                const cryptoType = this.payChannel
                this.currentOrderType = 'subscription'

                this.cleanupProcessedOrders()

                const saved = localStorage.getItem('pendingCryptoOrder')
                if (saved) {
                    const oldOrder = JSON.parse(saved)
                    const oldOrderImei = String(oldOrder.imei || '').trim()
                    const currentImei = String(this.Imei || '').trim()

                    if (!oldOrderImei || oldOrderImei !== currentImei) {
                        console.log('【安全】本地订单IMEI不匹配，清理')
                        localStorage.removeItem('pendingCryptoOrder')
                    } else {
                        const now = Math.floor(Date.now() / 1000)
                        const orderAge = now - oldOrder.create_time

                        if (orderAge > 300) {
                            console.log('【新建】旧订单超过10分钟，强制创建新订单')
                            localStorage.removeItem('pendingCryptoOrder')
                            this.savedOrder = null
                        }
                        else if (oldOrder.buy_num === pkg.buy_num &&
                            oldOrder.total_amount === pkg.total_amount &&
                            oldOrder.crypto_type === cryptoType &&
                            orderAge < 300) {

                            console.log('【恢复】发现同套餐未完成订单:', oldOrder.order_sn)

                            try {
                                const res = await this.$axios.post(
                                    'https://crypto.telezh.net/check.php',
                                    this.$qs.stringify({
                                        order_sn: oldOrder.order_sn,
                                        imei: this.Imei,
                                        order_type: 'subscription'
                                    }),
                                    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                                )

                                if (res.data.status == 1 && res.data.data.pay_status == 0 && !res.data.data.expired) {
                                    console.log('【恢复】继续倒计时')

                                    this.restoreCryptoOrder(oldOrder, pkg, 'subscription')

                                    this.releaseCreateLock()
                                    return
                                } else if (res.data.status == 1 && res.data.data.pay_status == 1) {
                                    console.log('【处理】旧订单已支付，加时间并创建新订单')
                                    const processedKey = 'processed_order_' + oldOrder.order_sn + '_subscription'

                                    if (!localStorage.getItem(processedKey)) {
                                        localStorage.setItem(processedKey, Date.now().toString())
                                        Toast({
                                            message: '检测到您已完成支付，已自动为您成功订阅！',
                                            position: 'top',
                                            duration: 3000
                                        })
                                        this.ftest(this.Imei)
                                    }

                                    localStorage.removeItem('pendingCryptoOrder')
                                    this.savedOrder = null

                                } else {
                                    console.log('【新建】旧订单状态异常，清理:', res.data)
                                    localStorage.removeItem('pendingCryptoOrder')
                                    this.savedOrder = null
                                }

                            } catch (e) {
                                console.error('【恢复】检测旧订单失败:', e)
                                localStorage.removeItem('pendingCryptoOrder')
                                this.savedOrder = null
                            }
                        } else if (orderAge < 300) {
                            this.savedOrder = oldOrder
                        } else {
                            console.log('【新建】旧订单已过期，清理')
                            localStorage.removeItem('pendingCryptoOrder')
                            this.savedOrder = null
                        }
                    }
                }

                this.initCryptoDialog('subscription')

                setTimeout(() => {
                    this.createCryptoOrder(pkg, null, cryptoType)
                }, 300)
            },

            async createCryptoOrder(pkg, amount, cryptoType) {
                try {
                    const res = await this.$axios.post(
                        'https://crypto.telezh.net/create.php',
                        this.$qs.stringify({
                            buy_num: pkg.buy_num,
                            total_amount: pkg.total_amount,
                            crypto_type: cryptoType,
                            Imei: this.Imei
                        }),
                        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                    )

                    if (res.data.status == 1) {
                        this.cryptoAddress = res.data.data.address
                        this.cryptoOrderSn = res.data.data.order_sn
                        this.cryptoAmount = res.data.data.crypto_amount

                        const orderInfo = {
                            order_sn: res.data.data.order_sn,
                            create_time: Math.floor(Date.now() / 1000),
                            crypto_type: cryptoType,
                            crypto_amount: res.data.data.crypto_amount,
                            address: res.data.data.address,
                            buy_num: pkg.buy_num,
                            total_amount: pkg.total_amount,
                            imei: String(this.Imei || '').trim()
                        }
                        localStorage.setItem('pendingCryptoOrder', JSON.stringify(orderInfo))
                        this.savedOrder = orderInfo
                        console.log('【订单】已保存:', orderInfo)

                        await this.generateCryptoQR(this.cryptoAddress, this.cryptoAmount, cryptoType)

                        this.cryptoQrLoading = false
                        this.releaseCreateLock()
                        this.startCryptoPolling()
                        this.startCryptoCountdown()
                    } else {
                        this.handleCryptoError(res.data.msg || '创建订单失败')
                    }
                } catch (err) {
                    this.handleCryptoError('网络连接失败，请检查网络后重试')
                }
            },

            // ==========================================
            // 虚拟币支付公共方法
            // ==========================================

            escapeHtml(text) {
                if (!text) return ''
                const div = document.createElement('div')
                div.textContent = text
                return div.innerHTML
            },

            onCryptoDialogClosed() {
                this.clearCryptoTimer();
                this.clearCryptoCountdownTimer();

                if (this.currentOrderType === 'value_added') {
                    this.cryptoStatus = 'waiting';
                    this.cryptoErrorMsg = '';
                    this.cryptoQrCode = '';
                    this.cryptoAddress = '';
                    this.cryptoAmount = '0.00';
                    this.cryptoOrderSn = '';
                }
            },

            async generateCryptoQR(address, amount, cryptoType) {
                try {
                    let uri;
                    if (cryptoType === 'usdt') {
                        uri = `tron:${address}?amount=${amount}&token=USDT`;
                    } else {
                        uri = `tron:${address}?amount=${amount}`;
                    }

                    const qrDataUrl = await QRCode.toDataURL(uri, {
                        width: 140,
                        margin: 1,
                        color: {
                            dark: '#000000',
                            light: '#ffffff'
                        }
                    });

                    this.cryptoQrCode = qrDataUrl;
                } catch (err) {
                    console.error('二维码生成失败:', err);
                    this.cryptoQrCode = '';
                }
            },

            startCryptoPolling() {
                this.clearCryptoTimer()
                this.pollingOrderSn = this.cryptoOrderSn
                this.cryptoTimer = setInterval(async () => {
                    if (this.pollingOrderSn !== this.cryptoOrderSn) {
                        console.log('【轮询】订单已变更，停止旧轮询')
                        this.clearCryptoTimer()
                        return
                    }
                    await this.checkCryptoPaymentStatus()
                }, 5000)
            },

            clearCryptoTimer() {
                if (this.cryptoTimer) {
                    clearInterval(this.cryptoTimer)
                    this.cryptoTimer = null
                }
                this.pollingOrderSn = null
            },

            startCryptoCountdown() {
                this.clearCryptoCountdownTimer()
                this.cryptoCountdownTimer = setInterval(() => {
                    if (this.cryptoCountdown > 0) {
                        this.cryptoCountdown--
                    } else {
                        this.clearCryptoCountdownTimer()
                        this.clearCryptoTimer()
                        this.cryptoStatus = 'failed'
                        this.cryptoErrorMsg = '支付超时，请重新下单'
                        Toast({ message: '支付超时，请重新下单', position: 'top' })
                    }
                }, 1000)
            },

            clearCryptoCountdownTimer() {
                if (this.cryptoCountdownTimer) {
                    clearInterval(this.cryptoCountdownTimer)
                    this.cryptoCountdownTimer = null
                }
            },

            async checkCryptoPaymentStatus() {
                if (this.cryptoStatus === 'failed' || this.cryptoStatus === 'success') {
                    return
                }

                try {
                    console.log('【轮询】查询订单状态:', this.cryptoOrderSn, 'order_type:', this.currentOrderType)

                    const res = await this.$axios.post(
                        'https://crypto.telezh.net/check.php',
                        this.$qs.stringify({
                            order_sn: this.cryptoOrderSn,
                            imei: this.Imei,
                            order_type: this.currentOrderType || 'subscription'
                        }),
                        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                    )

                    console.log('【轮询】返回数据:', res.data)

                    if (res.data.status == 1) {
                        const payStatus = res.data.data.pay_status

                        if (payStatus == 1) {
                            console.log('【轮询】支付成功！order_type:', this.currentOrderType)

                            if (res.data.data.imei && res.data.data.imei != this.Imei) {
                                console.error('【安全】订单归属校验失败！')
                                this.cryptoStatus = 'failed'
                                this.cryptoErrorMsg = '订单异常'
                                this.clearCryptoTimer()
                                this.clearCryptoCountdownTimer()
                                return
                            }

                            const processedKey = 'processed_order_' + this.cryptoOrderSn + '_' + this.currentOrderType
                            localStorage.setItem(processedKey, Date.now().toString())

                            if (this.currentOrderType === 'value_added') {
                                localStorage.removeItem('pendingVAOrder_' + this.currentServiceId)
                            } else {
                                localStorage.removeItem('pendingCryptoOrder')
                            }
                            this.savedOrder = null

                            this.cryptoStatus = 'success'
                            this.clearCryptoTimer()
                            this.clearCryptoCountdownTimer()

                            Toast({ message: '支付成功！', position: 'top' })

                            // 【新增】触发邀请奖励
                            if (this.currentOrderType === 'subscription') {
                                await this.triggerRebate();
                            }

                            if (this.currentOrderType === 'value_added') {
                                setTimeout(() => {
                                    this.crypto_show = false;
                                    this.activeTab = 1;
                                    this.updateIndicator();

                                    if (this.currentService && this.currentService.id === this.currentServiceId) {
                                        this.currentService.paid = true;
                                    }

                                    const serviceIndex = this.valueAddedServices.findIndex(s => s.id == this.currentServiceId);
                                    if (serviceIndex !== -1) {
                                        this.valueAddedServices.splice(serviceIndex, 1, {
                                            ...this.valueAddedServices[serviceIndex],
                                            paid: true
                                        });
                                    }

                                    this.serviceDetailShow = true;

                                    Toast({ message: '购买成功，现在可以查看服务详情', position: 'top', duration: 3000 });
                                }, 2000);
                            }
                            else {
                                setTimeout(() => {
                                    this.crypto_show = false
                                    this.ftest(this.Imei)
                                }, 3000)
                            }
                        } else if (payStatus == 2) {
                            this.cryptoStatus = 'confirming'
                        } else if (payStatus == 3) {
                            this.cryptoStatus = 'pending'
                        } else {
                            console.log('【轮询】等待支付，返回:', res.data.data)
                        }
                    } else {
                        console.error('【轮询】接口返回错误:', res.data.msg)
                    }
                } catch (err) {
                    console.error('【轮询】请求错误:', err)
                }
            },

            copyCryptoAddress() {
                if (!this.cryptoAddress) {
                    Toast({ message: '地址为空', position: 'top' })
                    return
                }

                if (navigator.clipboard) {
                    navigator.clipboard.writeText(this.cryptoAddress).then(() => {
                        Toast({ message: '地址已复制', position: 'top' })
                    }).catch(() => {
                        this.fallbackCopy(this.cryptoAddress)
                    })
                } else {
                    this.fallbackCopy(this.cryptoAddress)
                }
            },

            // ==========================================
            // 原有方法
            // ==========================================

            switchChannel() {},

            _confirm() {
                let tries = 3;
                const check = async () => {
                    if (this.order_sn && this.order_sn.startsWith('STVA')) {
                        const res = await this.$axios.get(
                            `${SVC_API}/stripe/callback.php?action=check&order_sn=${this.order_sn}&imei=${this.Imei}`
                        );

                        if (res.data.code == 1 && res.data.data.pay_status == 1) {
                            this.$toast({ message: '支付成功', position: 'top' });

                            const serviceId = this.currentServiceId || 0;
                            if (serviceId && this.currentService) {
                                this.currentService.paid = true;

                                const idx = this.valueAddedServices.findIndex(s => s.id == serviceId);
                                if (idx !== -1) {
                                    this.valueAddedServices.splice(idx, 1, {
                                        ...this.valueAddedServices[idx],
                                        paid: true
                                    });
                                }

                                this.qr_show = false;

                                if (!this.serviceDetailShow) {
                                    this.serviceDetailShow = true;
                                }

                                this.$toast({ message: '购买成功，现在可以查看服务详情', position: 'top', duration: 3000 });
                            }
                            return;
                        }
                    } else {
                        const res = await this.$axios.post(
                            'https://zhifu.telezh.net/charge/check_status',
                            this.$qs.stringify({ order_sn: this.order_sn })
                        );
                        if (res.data.status == 1) {
                            this.$toast({ message: '支付成功', position: 'top' });

                            // 【新增】触发邀请奖励
                            await this.triggerRebate();

                            this.ftest(this.Imei);
                            return;
                        }
                    }

                    tries--;
                    if (tries > 0) {
                        setTimeout(check, 2000);
                    } else {
                        this.$toast({ message: '支付未完成，请确认支付后重试', position: 'top' });
                    }
                };
                check();
            },

            onRefresh() {
                setTimeout(() => {
                    location.reload()
                    Toast('刷新成功')
                    this.isLoading = false
                }, 1200)
            },

            fallbackCopy(text) {
                try {
                    const el = document.createElement('textarea');
                    el.value = text;
                    el.readOnly = true;
                    el.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0;width:1px;height:1px;padding:0;border:0;outline:none;box-shadow:none;background:transparent;pointer-events:none;';
                    document.body.appendChild(el);

                    el.select();

                    if (el.setSelectionRange) {
                        el.setSelectionRange(0, text.length);
                    }

                    const result = document.execCommand('copy');

                    document.body.removeChild(el);

                    console.log('fallbackCopy 结果:', result);
                    return result === true;
                } catch (e) {
                    console.error('fallbackCopy 异常:', e);
                    return false;
                }
            },

            ultimateFallbackCopy(text) {
                try {
                    const div = document.createElement('div');
                    div.contentEditable = true;
                    div.textContent = text;
                    div.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0;width:1px;height:1px;overflow:hidden;white-space:pre-wrap;';
                    document.body.appendChild(div);

                    const range = document.createRange();
                    range.selectNodeContents(div);

                    const selection = window.getSelection();
                    selection.removeAllRanges();
                    selection.addRange(range);

                    const result = document.execCommand('copy');

                    selection.removeAllRanges();
                    document.body.removeChild(div);

                    return result === true;
                } catch (e) {
                    console.error('ultimateFallbackCopy 异常:', e);
                    return false;
                }
            },

            async copyText(text) {
                let success = false;

                if (navigator.clipboard && navigator.clipboard.writeText) {
                    try {
                        await navigator.clipboard.writeText(text);
                        success = true;
                    } catch (err) {
                        console.log('Clipboard API 失败:', err.name, err.message);
                    }
                }

                if (!success) {
                    success = this.fallbackCopy(text);
                }

                if (!success) {
                    success = this.ultimateFallbackCopy(text);
                }

                return success;
            },

            ftest(Imei) {
                this.Imei = Imei
                localStorage.setItem('lastImei', Imei)
                console.log('【ftest】设置 IMEI:', this.Imei, '长度:', this.Imei.length)

                this.$nextTick(() => {
                    this.loadServices().then(() => {
                        console.log('【ftest】loadServices 完成，服务数量:', this.valueAddedServices.length)
                    }).catch(err => {
                        console.error('【ftest】loadServices 失败:', err)
                    })
                })

                this.loadInviteStats().then(() => {
                    console.log('【ftest】loadInviteStats 完成, hasParent=', this.hasParent)
                }).catch(err => {
                    console.error('【ftest】loadInviteStats 失败:', err)
                }).finally(() => {
                    // 【新增】加载奖励统计
                    this.loadRebateStats().then(() => {
                        console.log('【ftest】loadRebateStats 完成')
                    }).catch(err => {
                        console.error('【ftest】loadRebateStats 失败:', err)
                    })

                    this.$axios.post(
                        'https://zhifu.telezh.net/charge/serviceValid',
                        this.$qs.stringify({ Imei: this.Imei }),
                        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                    ).then(res => {
                        this.end_Time = res.data.end_at
                        this.isActive = res.data.status === 1
                        this.status = this.isActive ? '订阅仍在服务期' : '订阅已到期'
                        this.checkSavedOrder()
                    })
                })
            },

            addgroup(val) {
                document.location = "appjs://webview?path=" + val
            },

            hideCrispForDialog() {
                if (window.$crisp && window.$crisp.push) {
                    try {
                        window.$crisp.push(['do', 'chat:close'])
                    } catch(e) {}
                }
                const styleId = 'crisp-dialog-hide-style'
                let style = document.getElementById(styleId)
                if (!style) {
                    style = document.createElement('style')
                    style.id = styleId
                    style.textContent = `
                        .cc-18ov6,
                        .crisp-client {
                            display: none !important;
                            visibility: hidden !important;
                            opacity: 0 !important;
                            pointer-events: none !important;
                        }
                    `
                    document.head.appendChild(style)
                }
            },

            showCrispForDialog() {
                const style = document.getElementById('crisp-dialog-hide-style')
                if (style) style.remove()
            },

            onInstallStarted() {
                console.log('【更新】Java 通知安装已启动');
                localStorage.setItem('tg_installed_version', UPDATE_CONFIG.latestVersion);
                this.updateInstalled = true;
                this.showUpdateBar = false;
            },

            onInstallFailed() {
                console.log('【更新】Java 通知安装失败');
                localStorage.removeItem('tg_installed_version');
                this.updateInstalled = false;
                this.showUpdateBar = true;
            },

            onInstallPermissionGranted() {
                console.log('【更新】权限已获取，恢复按钮');
                this.showUpdateBar = true;
            },

            async copyWebsite() {
                const website = 'www.Telegram.tw';
                const success = await this.copyText(website);
                if (success) {
                    Toast({ message: '网址已复制 快去分享吧', position: 'top' });
                } else {
                    Toast({ message: '复制失败，请长按手动复制', position: 'top' });
                }
            },

            openChannel() {
                this.addgroup('@tg_cnpd');
            },

            openGroup() {
                this.addgroup('@tg_cnqz');
            },

            openService() {
                this.addgroup('@tg_cnkf');
            },

            openRobotService() {
                this.addgroup('@tgzh_kf_bot');
            },

            async loadInviteStats() {
                if (!this.Imei || this.Imei.length < 10) {
                    setTimeout(() => this.loadInviteStats(), 500)
                    return
                }

                this.referralLoading = true

                try {
                    let clientIp = ''
                    try {
                        const ipRes = await fetch('https://api.ipify.org?format=json')
                        const ipData = await ipRes.json()
                        clientIp = ipData.ip
                    } catch(e) {
                        console.log('【loadInviteStats】获取IP失败:', e)
                    }

                    let apiUrl = `${INVITE_API}/stats.php?imei=${this.Imei}`
                    if (clientIp) {
                        apiUrl += `&client_ip=${encodeURIComponent(clientIp)}`
                    }

                    const res = await this.$axios.get(apiUrl)

                    if (res.data.code === 200) {
                        const data = res.data.data
                        this.inviteStats = {
                            totalInvites: data.totalInvites || 0,
                            monthInvites: data.monthInvites || 0,
                            totalGiftDays: data.totalGiftDays || 0
                        }
                        this.inviteLink = data.inviteLink || ''
                        this.inviteCode = data.inviteCode || ''
                        this.hasParent = data.hasParent || false
                        this.canBind = data.canBind !== undefined ? data.canBind : true
                        this.parentInviteCode = data.parentInviteCode || ''
                    }
                } catch (e) {
                    console.error('获取邀请数据失败:', e)
                } finally {
                    this.referralLoading = false
                }
            },

            showInviteHistory() {
                this.inviteHistoryShow = true
                this.inviteHistoryPage = 1
                this.inviteHistoryList = []
                this.inviteHistoryHasMore = true
                this.loadInviteHistory()
            },

            async loadInviteHistory() {
                if (!this.Imei || this.Imei.length < 10) {
                    Toast({ message: '设备信息获取中，请稍候', position: 'top' })
                    return
                }

                if (this.inviteHistoryLoading || !this.inviteHistoryHasMore) {
                    return
                }

                this.inviteHistoryLoading = true

                try {
                    const res = await this.$axios.get(
                        `${INVITE_API}/history.php?imei=${this.Imei}&page=${this.inviteHistoryPage}&pageSize=${this.inviteHistoryPageSize}`
                    )

                    if (res.data.code === 200) {
                        const data = res.data.data
                        const newList = data.list || []

                        this.inviteHistoryList = [...this.inviteHistoryList, ...newList]

                        const total = data.total || 0
                        const currentCount = this.inviteHistoryList.length
                        this.inviteHistoryHasMore = currentCount < total

                        if (this.inviteHistoryHasMore) {
                            this.inviteHistoryPage++
                        }
                    } else {
                        Toast({ message: res.data.msg || '获取邀请记录失败', position: 'top' })
                    }
                } catch (e) {
                    console.error('获取邀请记录失败:', e)
                    Toast({ message: '网络错误，请稍候再试', position: 'top' })
                } finally {
                    this.inviteHistoryLoading = false
                }
            },

            onHistoryScroll(e) {
                const scrollTop = e.target.scrollTop
                const scrollHeight = e.target.scrollHeight
                const clientHeight = e.target.clientHeight

                if (scrollTop + clientHeight >= scrollHeight - 50) {
                    this.loadInviteHistory()
                }
            },

            forceFixCrisp() {
                if (this.crispTimer) {
                    clearInterval(this.crispTimer)
                    this.crispTimer = null
                }
                let count = 0
                const maxCount = 200

                const timer = setInterval(() => {
                    document.querySelectorAll('.cc-13wro').forEach(el => {
                        el.style.setProperty('bottom', '69px', 'important')
                    })

                    const dialogs = document.querySelectorAll('.cc-w7v18')
                    dialogs.forEach(el => {
                        el.style.setProperty('position', 'fixed', 'important')
                        el.style.setProperty('top', '0', 'important')
                        el.style.setProperty('left', '0', 'important')
                        el.style.setProperty('right', '0', 'important')
                        el.style.setProperty('bottom', '32px', 'important')
                        el.style.setProperty('height', 'auto', 'important')
                    })

                    document.querySelectorAll('.cc-1mh91, .cc-1f516').forEach(el => {
                        el.style.setProperty('height', '100%', 'important')
                    })

                    count++
                    if (count >= maxCount) clearInterval(timer)
                }, 50)

                this.crispTimer = timer
            },

            stopCrispTimer() {
                if (this.crispTimer) {
                    clearInterval(this.crispTimer)
                    this.crispTimer = null
                    console.log('【Crisp】定时器已停止')
                }
            },

            loadCrisp() {
                const isCrispReady = window.$crisp &&
                    typeof window.$crisp.push === 'function' &&
                    window.CRISP_WEBSITE_ID === "79c0a886-96c2-4464-b49b-10802486a0db";

                if (isCrispReady) {
                    console.log('【Crisp】已就绪，跳过初始化')
                    this.setupCrispEvents()
                    return
                }

                console.log('【Crisp】需要初始化')
                window.$crisp = []
                window.CRISP_WEBSITE_ID = "79c0a886-96c2-4464-b49b-10802486a0db"

                const script = document.createElement('script')
                script.src = "https://client.crisp.chat/l.js"
                script.async = true
                document.head.appendChild(script)
            },

            async copyInviteLink() {
                if (!this.inviteLink) {
                    Toast({ message: '邀请链接加载中', position: 'top' });
                    return;
                }

                const success = await this.copyText(this.inviteLink);

                if (success) {
                    this.inviteCopied = true;
                    Toast({ message: '邀请链接已复制', position: 'top' });
                    setTimeout(() => {
                        this.inviteCopied = false;
                    }, 2000);
                } else {
                    Toast({ message: '复制失败，请长按链接手动复制', position: 'top' });
                }
            },

            acquireCreateLock() {
                if (this.isCreatingOrder) {
                    console.log('【锁】正在创建订单中，请稍候')
                    return false
                }
                this.isCreatingOrder = true
                return true
            },

            releaseCreateLock() {
                this.isCreatingOrder = false
            },

            cleanupProcessedOrders() {
                const now = Date.now()
                const keys = []
                for (let i = 0; i < localStorage.length; i++) {
                    const key = localStorage.key(i)
                    if (key && key.startsWith('processed_order_')) {
                        const timestamp = parseInt(localStorage.getItem(key))
                        if (now - timestamp > 24 * 60 * 60 * 1000) {
                            keys.push(key)
                        }
                    }
                }
                keys.forEach(key => localStorage.removeItem(key))
            },

            async checkSavedOrder() {
                try {
                    console.log('【checkSavedOrder】开始，this.Imei =', this.Imei)

                    this.cleanupProcessedOrders()

                    const saved = localStorage.getItem('pendingCryptoOrder')
                    console.log('【checkSavedOrder】saved =', saved ? '有' : '无')

                    if (!saved) {
                        console.log('【checkSavedOrder】无订单，返回')
                        return
                    }

                    const order = JSON.parse(saved)

                    const orderImei = String(order.imei || '').trim()
                    const currentImei = String(this.Imei || '').trim()

                    console.log('【checkSavedOrder】订单IMEI:', JSON.stringify(orderImei))
                    console.log('【checkSavedOrder】当前IMEI:', JSON.stringify(currentImei))
                    console.log('【checkSavedOrder】长度:', orderImei.length, currentImei.length)
                    console.log('【checkSavedOrder】是否相等:', orderImei === currentImei)

                    if (orderImei && orderImei !== currentImei) {
                        console.log('【检测】订单不属于当前设备，清理')
                        localStorage.removeItem('pendingCryptoOrder')
                        this.savedOrder = null
                        return
                    }

                    const res = await this.$axios.post(
                        'https://crypto.telezh.net/check.php',
                        this.$qs.stringify({
                            order_sn: order.order_sn,
                            imei: this.Imei
                        }),
                        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                    )

                    console.log('【检测】订单状态:', res.data)

                    if (res.data.status == 1 && res.data.data.pay_status == 1) {
                        const processedKey = 'processed_order_' + order.order_sn

                        if (!localStorage.getItem(processedKey)) {
                            localStorage.setItem(processedKey, Date.now().toString())
                            Toast({
                                message: '检测到您已完成支付，已自动为您成功订阅！',
                                position: 'top',
                                duration: 3000
                            })
                            this.ftest(this.Imei)
                        }

                        localStorage.removeItem('pendingCryptoOrder')
                        this.savedOrder = null
                        return
                    }

                    if (res.data.data && res.data.data.expired) {
                        console.log('【检测】订单已过期，清理')
                        localStorage.removeItem('pendingCryptoOrder')
                        this.savedOrder = null
                        return
                    }

                    console.log('【检测】订单等待支付，保留')
                    this.savedOrder = order

                } catch (err) {
                    console.error('【检测】检查保存订单失败:', err)
                }
            },

            initCrispListener() {
                const checkCrisp = setInterval(() => {
                    if (window.$crisp && window.$crisp.push) {
                        clearInterval(checkCrisp)
                        this.setupCrispEvents()
                    }
                }, 500)
                setTimeout(() => {
                    clearInterval(checkCrisp)
                }, 10000)
            },

            setupCrispEvents() {
                if (window.$crisp) {
                    try {
                        window.$crisp.push(['off', 'chat:opened'])
                        window.$crisp.push(['off', 'chat:closed'])
                    } catch(e) {}
                }

                window.$crisp.push(['on', 'chat:opened', () => {
                    this.chatOpened = true
                    this.notifyChatStateChanged(true)
                }])

                window.$crisp.push(['on', 'chat:closed', () => {
                    this.chatOpened = false
                    this.notifyChatStateChanged(false)
                }])

                this.crispInitialized = true
                this.checkInitialChatState()
            },

            checkInitialChatState() {
                setTimeout(() => {
                    const isOpened = this.isCrispChatVisible()
                    this.chatOpened = isOpened
                    this.notifyChatStateChanged(isOpened)
                }, 300)
            },

            isCrispChatVisible() {
                try {
                    const chatBox = document.querySelector('.crisp-chatbox')
                    if (!chatBox) return false
                    const style = window.getComputedStyle(chatBox)
                    return style.display !== 'none' &&
                        style.visibility !== 'hidden' &&
                        parseFloat(style.opacity) > 0
                } catch (e) {
                    return false
                }
            },

            notifyChatStateChanged(opened) {
                console.log('【Vue】通知 Android 客服状态:', opened, 'window.$App:', !!window.$App)
                if (window.$App && window.$App.onChatStateChanged) {
                    try {
                        window.$App.onChatStateChanged(opened)
                        console.log('【Vue】通知成功')
                    } catch (e) {
                        console.error('【Vue】通知失败:', e)
                    }
                } else {
                    console.log('【Vue】window.$App 不存在')
                }
            },

            checkPaymentReturn() {
                const urlParams = new URLSearchParams(window.location.search);
                const channel = urlParams.get('channel');

                if (channel) {
                    setTimeout(() => {
                        if (this.Imei) this.ftest(this.Imei);
                    }, 500);
                }

                const stripeSuccess = urlParams.get('stripe_success');
                const stripeOrder = localStorage.getItem('pendingStripeOrder');

                if (stripeSuccess === 'true' && stripeOrder) {
                    const order = JSON.parse(stripeOrder);

                    if (order.activeTab !== undefined) {
                        this.activeTab = order.activeTab;
                        this.updateIndicator();
                    }

                    if (order.service) {
                        this.currentService = { ...order.service, paid: false };
                        this.currentServiceId = order.service_id;
                    }

                    if (this.Imei && this.Imei.length >= 10) {
                        this.checkStripePaymentAndUpdate(order.order_sn, order.service_id);
                    } else {
                        setTimeout(() => {
                            if (this.Imei && this.Imei.length >= 10) {
                                this.checkStripePaymentAndUpdate(order.order_sn, order.service_id);
                            } else {
                                Toast({ message: '设备信息获取失败，请刷新页面', position: 'top' });
                                localStorage.removeItem('pendingStripeOrder');
                            }
                        }, 1500);
                    }
                } else if (stripeSuccess === 'false' && stripeOrder) {
                    Toast({ message: '支付已取消', position: 'top' });
                    localStorage.removeItem('pendingStripeOrder');
                }
            },

            async checkStripePaymentAndUpdate(orderSn, serviceId) {
                try {
                    const res = await this.$axios.get(
                        `${SVC_API}/stripe/callback.php?action=check&order_sn=${orderSn}&imei=${this.Imei}`
                    );

                    if (res.data.code == 1 && res.data.data.pay_status == 1) {
                        Toast({ message: '支付成功！', position: 'top', duration: 3000 });

                        if (this.currentService && this.currentService.id == serviceId) {
                            this.currentService.paid = true;
                        }

                        const serviceIndex = this.valueAddedServices.findIndex(s => s.id == serviceId);
                        if (serviceIndex !== -1) {
                            this.valueAddedServices.splice(serviceIndex, 1, {
                                ...this.valueAddedServices[serviceIndex],
                                paid: true
                            });
                        }

                        if (!this.serviceDetailShow) {
                            this.serviceDetailShow = true;
                        }

                        this.loadServices();

                        localStorage.removeItem('pendingStripeOrder');

                        window.history.replaceState({}, document.title, window.location.pathname);
                    } else if (res.data.code == 1 && res.data.data.expired) {
                        Toast({ message: '订单已过期，请重新支付', position: 'top' });
                        localStorage.removeItem('pendingStripeOrder');
                    } else if (res.data.code == 1 && res.data.data.pay_status == 0) {
                        Toast({ message: '支付未完成，请重新支付', position: 'top' });
                    } else {
                        Toast({ message: res.data.msg || '查询支付状态失败', position: 'top' });
                        localStorage.removeItem('pendingStripeOrder');
                    }
                } catch (e) {
                    console.error('查询支付状态失败:', e);
                    Toast({ message: '网络错误，请稍候再试', position: 'top' });
                }
            },

            onDownloadProgress(progress, downloadedBytes, totalBytes) {
                this.downloadProgress = progress
            },

            onDownloadComplete() {
                console.log('【更新】下载完成回调');
                this.isDownloading = false;
                this.downloadComplete = true;
                this.downloadProgress = 100;

                Toast({ message: '下载完成，点击安装', position: 'top' });
            },

            checkUpdate() {
                if (window.$App && typeof $App.getVersion === 'function') {
                    try {
                        this.currentVersion = $App.getVersion();
                        this.hasNativeSupport = true;
                    } catch (e) {
                        this.currentVersion = null;
                        this.hasNativeSupport = false;
                    }
                } else {
                    this.hasNativeSupport = false;
                    this.currentVersion = null;
                }

                if (!this.hasNativeSupport || !this.currentVersion) {
                    const installedVersion = localStorage.getItem('tg_installed_version');
                    if (installedVersion === UPDATE_CONFIG.latestVersion) {
                        console.log('【更新检测】无原生支持但已安装过，隐藏');
                        this.showUpdateBar = false;
                        this.updateInstalled = true;
                        return;
                    }

                    this.showUpdateBar = true;
                    return;
                }

                const installedVersion = localStorage.getItem('tg_installed_version');
                if (installedVersion === UPDATE_CONFIG.latestVersion) {
                    console.log('【更新检测】已安装过此版本，强制隐藏');
                    this.showUpdateBar = false;
                    this.updateInstalled = true;
                    return;
                }

                if (this.compareVersion(this.currentVersion, UPDATE_CONFIG.latestVersion) < 0) {
                    this.showUpdateBar = true;
                    this.updateInstalled = false;
                } else {
                    this.showUpdateBar = false;
                    this.updateInstalled = false;
                }
            },

            compareVersion(v1, v2) {
                const arr1 = v1.split('.').map(Number)
                const arr2 = v2.split('.').map(Number)
                const len = Math.max(arr1.length, arr2.length)
                for (let i = 0; i < len; i++) {
                    const num1 = arr1[i] || 0
                    const num2 = arr2[i] || 0
                    if (num1 < num2) return -1
                    if (num1 > num2) return 1
                }
                return 0
            },

            handleUpdateClick() {
                if (this.downloadComplete) {
                    this.installUpdate();
                    return;
                }

                if (this.isDownloading) {
                    return;
                }

                if (this.hasNativeSupport && window.$App && window.$App.downloadAndInstall) {
                    this.isDownloading = true;
                    this.downloadProgress = 0;
                    try {
                        $App.downloadAndInstall(UPDATE_CONFIG.downloadUrl);
                    } catch (e) {
                        console.error('【更新】原生下载失败:', e);
                        this.isDownloading = false;
                        this.openBrowserDownload();
                    }
                } else {
                    this.openBrowserDownload();
                }
            },

            installUpdate() {
                console.log('【更新】开始安装流程');

                if (window.$App && window.$App.installApk) {
                    try {
                        this.showUpdateBar = false;
                        $App.installApk();
                    } catch (e) {
                        console.error('【更新】安装失败:', e);
                        this.showUpdateBar = true;
                        window.location.href = UPDATE_CONFIG.downloadUrl;
                    }
                } else {
                    window.location.href = UPDATE_CONFIG.downloadUrl;
                }
            },

            openBrowserDownload() {
                window.location.href = UPDATE_CONFIG.downloadUrl
            },

            getAvatarColor(name) {
                if (!name) return TG_AVATAR_COLORS[0]
                let hash = 0
                for (let i = 0; i < name.length; i++) {
                    hash = name.charCodeAt(i) + ((hash << 5) - hash)
                }
                const index = Math.abs(hash) % TG_AVATAR_COLORS.length
                return TG_AVATAR_COLORS[index]
            },

            getFirstLetter(name) {
                if (!name) return 'T'
                return name.charAt(0).toUpperCase()
            },

            async initData() {
                await this.getCurrencyUser()
                await new Promise(resolve => {
                    const checkImei = setInterval(() => {
                        const imeiStr = String(this.Imei || '').trim()
                        if (imeiStr.length >= 32) {
                            clearInterval(checkImei)
                            resolve()
                        }
                    }, 100)
                    setTimeout(() => {
                        clearInterval(checkImei)
                        resolve()
                    }, 5000)
                })
                await this.getUserAvatar()
            },

            getCurrencyUser() {
                return new Promise((resolve) => {
                    try {
                        let userstr = $App.getCurrencyUser()
                        if (!userstr || typeof userstr !== 'string') {
                            resolve()
                            return
                        }
                        let str = String(userstr).split(';')
                        this.phone = str[0] || ''
                        if (str[1]) {
                            this.name = str[1].replace(/null/gi, '').trim()
                        } else {
                            this.name = ''
                        }
                        if (str.length >= 3 && str[2] && str[2].trim() && str[2].trim().toLowerCase() !== 'null') {
                            this.username = str[2].trim()
                        } else {
                            this.username = ''
                        }
                    } catch (e) {
                        this.phone = ''
                        this.name = ''
                        this.username = ''
                    }
                    resolve()
                })
            },

            getUserAvatar() {
                return new Promise((resolve) => {
                    try {
                        let avatarBase64 = $App.getUserAvatarBase64()
                        if (avatarBase64 && avatarBase64.length > 100) {
                            this.avatarUrl = avatarBase64
                        } else {
                            this.avatarUrl = ''
                        }
                    } catch (e) {
                        this.avatarUrl = ''
                    }
                    resolve()
                })
            },

            onAvatarError() {
                this.avatarUrl = ''
            },

            async getRate() {
                try {
                    const res = await fetch('https://api.exchangerate-api.com/v4/latest/HKD')
                    const json = await res.json()
                    return json.rates.CNY
                } catch {
                    return 0.9
                }
            },

            updateIndicator() {
                this.$nextTick(() => {
                    const track = this.$refs.navTrack
                    if (!track) return

                    const items = track.querySelectorAll('.tg-nav-item-refined')
                    if (!items || !items[this.activeTab]) return

                    const item = items[this.activeTab]
                    const trackRect = track.getBoundingClientRect()
                    const itemRect = item.getBoundingClientRect()

                    const trackPadding = 4
                    const left = itemRect.left - trackRect.left - trackPadding
                    const width = itemRect.width * 0.85
                    const offset = (itemRect.width - width) / 2

                    this.indicatorStyle = {
                        transform: `translateX(${left + offset}px)`,
                        width: `${width}px`
                    }
                })
            },
        }
    }
</script>
<style scoped lang="css">
    /* ========================================== */
    /* 全局基础 */
    /* ========================================== */
    ::-webkit-scrollbar {
        width: 0 !important;
        height: 0 !important;
        background: transparent !important;
        display: none !important;
    }

    * {
        scrollbar-width: none !important;
        -ms-overflow-style: none !important;
    }

    :global(.crisp-client),
    :global(#crisp-chatbox),
    :global([class*="crisp-"]) {
        -webkit-transform: translateZ(0) !important;
        transform: translateZ(0) !important;
        -webkit-backface-visibility: hidden !important;
        backface-visibility: hidden !important;
        will-change: auto !important;
    }

    .tg-section {
        margin: 8px 12px;
        max-width: 100%;
    }

    .tg-card {
        background: #ffffff;
        border-radius: 16px;
        overflow: hidden;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    }

    /* ========================================== */
    /* 板块一：会员信息 */
    /* ========================================== */
    .tg-profile-card {
        padding: 12px 12px;
    }

    .tg-profile-header {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
    }

    .tg-avatar-wrap {
        position: relative;
        margin-right: 12px;
        flex-shrink: 0;
    }

    .tg-avatar-img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        object-fit: cover;
        border: 2px solid #fff;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    .tg-avatar {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
        border: 2px solid #fff;
    }

    .tg-avatar-letter {
        font-size: 24px;
        font-weight: 600;
        color: #ffffff;
        text-transform: uppercase;
    }

    .tg-profile-info {
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
    }

    .tg-name-row {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 6px;
        width: 100%;
    }

    .tg-phone-row {
        display: flex;
        align-items: center;
        gap: 6px;
        width: 100%;
        margin-bottom: 6px;
    }

    .tg-phone {
        font-size: 14px;
        color: #8e8e93;
        font-weight: 400;
    }

    .tg-username-row {
        display: flex;
        align-items: center;
        width: 100%;
        gap: 4px;
    }

    .tg-username-at {
        font-size: 14px;
        color: #8e8e93;
        font-weight: 400;
    }

    .tg-info-list {
        padding: 0;
    }

    .tg-info-item {
        display: flex;
        align-items: center;
        padding: 7px 0;
    }

    .tg-info-icon {
        width: 18px;
        height: 18px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 5px;
        flex-shrink: 0;
        color: #fff;
    }

    .tg-info-icon.blue { background: #3b82f6; }
    .tg-info-icon.purple { background: #8b5cf6; }
    .tg-info-icon.green { background: #10b981; }
    .tg-info-icon.red { background: #ef4444; }
    .tg-info-icon.teal { background: linear-gradient(135deg, #14b8a6, #0d9488); }
    .tg-info-icon.browser { background: linear-gradient(135deg, #3b82f6, #2563eb); }
    .tg-info-icon.service { background: linear-gradient(135deg, #f59e0b, #d97706); }

    .tg-info-label {
        font-size: 14px;
        color: #374151;
        font-weight: 400;
        flex-shrink: 0;
        min-width: 52px;
    }

    .tg-info-value {
        font-size: 13px;
        color: #374151;
        font-weight: 500;
        flex: 1;
        text-align: left;
        padding-left: 6px;
    }

    .tg-info-value.device-code {
        font-size: 11px;
        letter-spacing: 0.1px;
        white-space: nowrap;
    }

    .tg-divider {
        height: 1px;
        background: #f3f4f6;
        margin: 0;
    }

    .network-gif {
        width: 12px;
        height: 13px;
        object-fit: contain;
    }

    /* ========================================== */
    /* 频道群组入口行样式 */
    /* ========================================== */
    .tg-info-item.community-item {
        padding: 5px 0;
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
    }

    .tg-community-btns {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-left: auto;
        flex-shrink: 0;
    }

    .tg-community-btn {
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 5px 10px;
        border: none;
        border-radius: 10px;
        font-size: 11px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s ease;
        white-space: nowrap;
        flex-shrink: 0;
    }

    .tg-community-btn.channel {
        background: linear-gradient(135deg, #0ea5e9, #0284c7);
        color: #fff;
        box-shadow: 0 2px 8px rgba(14, 165, 233, 0.3);
    }

    .tg-community-btn.group {
        background: linear-gradient(135deg, #8b5cf6, #7c3aed);
        color: #fff;
        box-shadow: 0 2px 8px rgba(139, 92, 246, 0.3);
    }

    .tg-community-btn:active {
        transform: scale(0.95);
        opacity: 0.9;
    }

    .tg-community-btn span {
        font-size: 11px;
    }

    /* ========================================== */
    /* 联系客服行样式 */
    /* ========================================== */
    .tg-info-item.service-item {
        padding: 5px 0;
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
    }

    .tg-service-btns {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-left: auto;
        flex-shrink: 0;
    }

    .tg-service-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        padding: 5px 10px;
        background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
        color: #fff;
        border: none;
        border-radius: 10px;
        font-size: 11px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s ease;
        white-space: nowrap;
        flex-shrink: 0;
        box-shadow: 0 2px 8px rgba(245, 158, 11, 0.3);
    }

    .tg-service-btn.robot {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
    }

    .tg-service-btn:active {
        transform: scale(0.95);
        opacity: 0.9;
    }

    /* ========================================== */
    /* 下载网址复制按钮样式 */
    /* ========================================== */
    .tg-info-item.website-item {
        padding: 5px 0;
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
    }

    .tg-info-value.website-value {
        font-size: 13px;
        color: #0369a1;
        font-weight: 600;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        flex: 0 0 auto;
        margin-right: 8px;
    }

    .tg-copy-share-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        padding: 5px 10px;
        background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%);
        color: #fff;
        border: none;
        border-radius: 10px;
        font-size: 11px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s ease;
        white-space: nowrap;
        flex-shrink: 0;
        margin-left: auto;
        box-shadow: 0 2px 8px rgba(14, 165, 233, 0.3);
    }

    .tg-copy-share-btn:active {
        transform: scale(0.95);
        opacity: 0.9;
    }

    .tg-copy-share-btn svg {
        display: block;
        flex-shrink: 0;
    }

    /* ========================================== */
    /* 板块二：精致浅色导航栏（横向图标+文字） */
    /* ========================================== */
    .tg-nav-card-refined {
        display: flex;
        align-items: center;
        position: relative;
        background: #ffffff;
        border-radius: 14px;
        padding: 4px;
        box-shadow:
                0 2px 8px rgba(36, 161, 222, 0.06),
                0 1px 3px rgba(0, 0, 0, 0.04),
                inset 0 1px 0 rgba(255, 255, 255, 0.8);
        border: 1px solid rgba(224, 242, 254, 0.8);
    }

    .tg-nav-item-refined {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;
        padding: 8px 0;
        font-size: 13px;
        font-weight: 500;
        color: #94a3b8;
        border-radius: 10px;
        cursor: pointer;
        position: relative;
        z-index: 2;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        user-select: none;
        -webkit-tap-highlight-color: transparent;
        letter-spacing: 0.3px;
    }

    .tg-nav-item-refined .van-icon {
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        color: inherit;
    }

    .tg-nav-item-refined.active {
        color: #ffffff;
        font-weight: 600;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    }

    .tg-nav-item-refined.active .van-icon {
        color: #ffffff;
    }

    @media (hover: hover) {
        .tg-nav-item-refined:not(.active):hover {
            color: #64748b;
        }
    }

    .tg-nav-item-refined:active {
        transform: scale(0.97);
    }

    .tg-nav-indicator-refined {
        position: absolute;
        top: 4px;
        bottom: 4px;
        left: 4px;
        height: auto;
        background: linear-gradient(135deg, #24A1DE 0%, #0ea5e9 100%);
        border-radius: 10px;
        z-index: 1;
        transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
        box-shadow:
                0 3px 10px rgba(36, 161, 222, 0.2),
                0 1px 3px rgba(36, 161, 222, 0.12),
                inset 0 1px 0 rgba(255, 255, 255, 0.2);
    }

    .tg-tab-content {
        animation: tabFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }

    @keyframes tabFadeIn {
        from { opacity: 0; transform: translateY(6px); }
        to { opacity: 1; transform: translateY(0); }
    }

    /* ========================================== */
    /* 增值服务列表 */
    /* ========================================== */
    .tg-value-added-card {
        padding: 12px 12px;
        background: #ffffff;
        border-radius: 16px;
        overflow: hidden;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    }

    .tg-service-list {
        padding: 0;
    }

    .tg-service-item {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 10px 0;
        border-bottom: 1px solid #f0f2f5;
        cursor: pointer;
        transition: background 0.2s;
    }

    .tg-service-item:last-child {
        border-bottom: none;
    }

    .tg-service-item:active {
        background: #f8f9fa;
    }

    .tg-service-icon {
        width: 26px;
        height: 26px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .tg-service-info {
        flex: 1;
        min-width: 0;
    }

    .tg-service-title {
        font-size: 15px;
        font-weight: 600;
        color: #1a1a2e;
        margin-bottom: 3px;
    }

    .tg-service-desc {
        font-size: 13px;
        color: #8e8e93;
        margin-bottom: 4px;
        line-height: 1.4;
        word-break: break-all;
    }

    .tg-service-meta {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .tg-service-price {
        font-size: 13px;
        font-weight: 600;
        color: #f59e0b;
        padding: 2px 8px;
        border-radius: 6px;
        background: #fef3c7;
        display: inline-block;
    }

    .tg-service-tag.free {
        font-size: 12px;
        padding: 2px 8px;
        border-radius: 6px;
        background: #e8f5e9;
        color: #4caf50;
        font-weight: 500;
    }

    .tg-service-tag.custom {
        font-size: 12px;
        padding: 2px 8px;
        border-radius: 6px;
        background: #f3e8ff;
        color: #8b5cf6;
        font-weight: 500;
    }

    .tg-service-tag.purchased {
        font-size: 12px;
        padding: 2px 8px;
        border-radius: 6px;
        background: #e0f2fe;
        color: #0ea5e9;
        font-weight: 500;
    }

    .tg-service-views {
        font-size: 12px;
        color: #8e8e93;
        display: flex;
        align-items: center;
        gap: 3px;
    }

    .tg-service-arrow {
        flex-shrink: 0;
        width: 20px;
        margin-left: 0;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    .tg-service-tag-icon {
        display: inline-flex;
        align-items: center;
        gap: 2px;
        margin-left: 4px;
        vertical-align: middle;
    }

    .tag-text {
        color: #ff4d4f;
        font-weight: 600;
        font-size: 11px;
    }

    .tg-category-list {
        display: flex;
        flex-direction: column;
        gap: 12px;
        margin-top: 12px;
    }

    .tg-category-card {
        border-radius: 14px;
        padding: 14px 10px;
        border: 1px solid #e8f4fc;
        box-shadow: 0 2px 8px rgba(36, 161, 222, 0.06);
        transition: all 0.3s ease;
    }

    .tg-category-header {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 10px;
        padding-bottom: 10px;
        border-bottom: 1px dashed #e0f2fe;
    }

    .tg-category-bar {
        width: 4px;
        height: 18px;
        border-radius: 2px;
        flex-shrink: 0;
    }

    .tg-category-name {
        font-size: 15px;
        font-weight: 700;
        flex: 1;
    }

    .tg-category-count {
        font-size: 11px;
        color: #7eb8e0;
        background: #f0f9ff;
        padding: 3px 10px;
        border-radius: 10px;
        font-weight: 500;
        border: 1px solid #e0f2fe;
    }

    .tg-category-services {
        display: flex;
        flex-direction: column;
    }

    .tg-category-services .tg-service-item {
        padding: 10px 0;
        border-bottom: 1px solid #f0f7ff;
    }

    .tg-category-services .tg-service-item:last-child {
        border-bottom: none;
        padding-bottom: 0;
    }

    .tg-category-services .tg-service-item:first-child {
        padding-top: 2px;
    }

    .tg-category-card:active {
        transform: scale(0.995);
        box-shadow: 0 4px 12px rgba(36, 161, 222, 0.1);
    }

    .tg-category-empty {
        text-align: center;
        padding: 40px 20px;
        color: #94a3b8;
        font-size: 14px;
    }

    /* ========================================== */
    /* 动态效果 */
    /* ========================================== */
    .highlight-pulse .tg-service-title-text {
        animation: title-pulse 2s ease-in-out infinite;
    }

    @keyframes title-pulse {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.4; }
    }

    .highlight-shimmer .tg-service-title-text {
        background: linear-gradient(90deg, #1a1a2e 0%, #ff4d4f 50%, #1a1a2e 100%);
        background-size: 200% 100%;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        animation: title-shimmer 2s linear infinite;
    }

    @keyframes title-shimmer {
        0% { background-position: 200% 0; }
        100% { background-position: -200% 0; }
    }

    .highlight-glow .tg-service-title-text {
        animation: title-glow 1.5s ease-in-out infinite alternate;
    }

    @keyframes title-glow {
        from { text-shadow: 0 0 2px rgba(255, 77, 79, 0.3); }
        to { text-shadow: 0 0 8px rgba(255, 77, 79, 0.6), 0 0 15px rgba(255, 77, 79, 0.3); }
    }

    .highlight-shake .tg-service-title-text {
        animation: title-shake 0.6s ease-in-out infinite;
    }

    @keyframes title-shake {
        0%, 100% { letter-spacing: 0; }
        25% { letter-spacing: 1px; }
        75% { letter-spacing: -1px; }
    }

    .highlight-scale .tg-service-title-text {
        animation: title-scale 2s ease-in-out infinite;
    }

    @keyframes title-scale {
        0%, 100% { font-size: 15px; }
        50% { font-size: 16.5px; }
    }

    .highlight-rainbow .tg-service-title-text {
        animation: title-rainbow 3s linear infinite;
    }

    @keyframes title-rainbow {
        0% { color: #ff0000; }
        17% { color: #ff8000; }
        33% { color: #ffff00; }
        50% { color: #00ff00; }
        67% { color: #0000ff; }
        83% { color: #8000ff; }
        100% { color: #ff0000; }
    }

    .highlight-neon .tg-service-title-text {
        animation: title-neon 1.5s ease-in-out infinite alternate;
    }

    @keyframes title-neon {
        from {
            color: #ff4d4f;
            text-shadow: 0 0 5px rgba(255, 77, 79, 0.5);
        }
        to {
            color: #ff7875;
            text-shadow: 0 0 10px rgba(255, 77, 79, 0.8), 0 0 20px rgba(255, 77, 79, 0.4);
        }
    }

    .highlight-wave .tg-service-title-text {
        border-bottom: 2px solid transparent;
        animation: title-wave 2s ease-in-out infinite;
    }

    @keyframes title-wave {
        0%, 100% { border-bottom-color: transparent; }
        50% { border-bottom-color: #ff4d4f; }
    }

    .highlight-sparkle .tg-service-title-text {
        position: relative;
    }

    .highlight-sparkle .tg-service-title-text::before {
        content: '✨';
        position: absolute;
        left: -20px;
        top: 50%;
        margin-top: -8px;
        font-size: 12px;
        animation: title-sparkle 1.5s ease-in-out infinite;
    }

    @keyframes title-sparkle {
        0%, 100% { opacity: 0; }
        50% { opacity: 1; }
    }

    .highlight-flash-color .tg-service-title-text {
        animation: title-flash-color 1.2s ease-in-out infinite;
    }

    @keyframes title-flash-color {
        0%, 100% { color: #1a1a2e; }
        50% { color: #ff4d4f; }
    }

    .highlight-shadow-pulse .tg-service-title-text {
        animation: title-shadow-pulse 2s ease-in-out infinite;
    }

    @keyframes title-shadow-pulse {
        0%, 100% { text-shadow: 0 0 2px rgba(36, 161, 222, 0.3); }
        50% { text-shadow: 0 0 8px rgba(36, 161, 222, 0.6), 0 0 15px rgba(36, 161, 222, 0.3); }
    }

    .highlight-star-trail .tg-service-title-text {
        position: relative;
    }

    .highlight-star-trail .tg-service-title-text::after {
        content: '⭐';
        position: absolute;
        right: -18px;
        top: 0;
        font-size: 12px;
        animation: title-star-trail 1.5s ease-in-out infinite;
    }

    @keyframes title-star-trail {
        0%, 100% { opacity: 0; transform: translateX(0); }
        50% { opacity: 1; transform: translateX(-4px); }
    }

    .highlight-battery .tg-service-title-text {
        animation: title-battery 2s steps(4, end) infinite;
    }

    @keyframes title-battery {
        0%, 100% { opacity: 1; }
        25% { opacity: 0.3; }
        50% { opacity: 1; }
        75% { opacity: 0.3; }
    }

    .highlight-heart-dot .tg-service-title-text {
        position: relative;
        padding-left: 14px;
    }

    .highlight-heart-dot .tg-service-title-text::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        margin-top: -4px;
        width: 8px;
        height: 8px;
        background: #ff4d4f;
        border-radius: 50%;
        animation: title-heart-dot 1.2s ease-in-out infinite;
    }

    @keyframes title-heart-dot {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.2; }
    }

    .highlight-breathing-dots .tg-service-title-text::after {
        content: '···';
        letter-spacing: 2px;
        margin-left: 4px;
        color: #24A1DE;
        animation: title-breathing-dots 1.5s ease-in-out infinite;
    }

    @keyframes title-breathing-dots {
        0%, 100% { opacity: 0.3; }
        50% { opacity: 1; }
    }

    .highlight-warning .tg-service-title-text {
        animation: title-warning 0.8s steps(2, end) infinite;
        padding: 0 4px;
        border-radius: 4px;
    }

    @keyframes title-warning {
        0%, 100% { background-color: transparent; }
        50% { background-color: rgba(255, 77, 79, 0.15); }
    }

    /* ========================================== */
    /* 增值服务详情弹窗 */
    /* ========================================== */
    .tg-service-detail-popup {
        display: flex;
        flex-direction: column;
    }

    .tg-service-detail-title {
        flex: 1;
        font-size: 17px;
        font-weight: 600;
        color: #1a1a2e;
    }

    .tg-service-detail-body {
        flex: 1;
        overflow-y: auto;
        padding: 20px;
        -webkit-overflow-scrolling: touch;
    }

    .tg-service-detail-content {
        font-size: 14px;
        line-height: 1.8;
        color: #333;
    }

    .tg-service-detail-popup {
        background: #f0f2f5 !important;
    }

    .tg-service-detail-body {
        flex: 1;
        overflow-y: auto;
        padding: 8px;
        -webkit-overflow-scrolling: touch;
        background: #f0f2f5;
    }

    .tg-service-detail-header {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 8px 20px;
        border-bottom: 1px solid #f0f2f5;
        flex-shrink: 0;
        background: #ffffff;
    }

    .tg-service-detail-icon {
        width: 34px;
        height: 34px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    .tg-service-detail-title {
        flex: 1;
        font-size: 17px;
        font-weight: 700;
        color: #1f2937;
    }

    .tg-service-info-card-v2 {
        padding: 12px 14px;
        background: #ffffff;
        border-radius: 12px;
        margin-bottom: 8px;
        border: 1px solid #e2e8f0;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
        display: flex;
        align-items: flex-start;
        gap: 12px;
        position: relative;
        overflow: hidden;
    }

    .service-info-left-bar {
        width: 3px;
        height: 36px;
        background: linear-gradient(180deg, #24A1DE, #0ea5e9, #38bdf8);
        border-radius: 2px;
        flex-shrink: 0;
        margin-top: 2px;
        box-shadow: 0 2px 8px rgba(36, 161, 222, 0.3);
    }

    .service-info-content-v2 {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .service-info-desc-v2 {
        font-size: 13px;
        color: #64748b;
        line-height: 1.5;
    }

    .service-info-badge-v2 {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        padding: 3px 10px;
        background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
        border-radius: 20px;
        font-size: 11px;
        color: #fff;
        font-weight: 600;
        align-self: flex-start;
    }

    .tg-service-pay-channel-section-v2 {
        margin-bottom: 8px;
        background: #ffffff;
        border-radius: 12px;
        border: 1px solid #e5e7eb;
        overflow: hidden;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
    }

    .tg-service-pay-channel-title-v2 {
        font-size: 13px;
        font-weight: 700;
        color: #374151;
        padding: 10px 14px;
        border-bottom: 1px solid #f3f4f6;
        background: #fafbfc;
    }

    .tg-service-pay-channel-item-v2 {
        display: flex;
        align-items: center;
        padding: 10px 14px;
        cursor: pointer;
        transition: all 0.2s ease;
        min-height: 44px;
        box-sizing: border-box;
        position: relative;
        background: #ffffff;
    }

    .tg-service-pay-channel-item-v2.active {
        background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
    }

    .pay-channel-active-bar-v2 {
        position: absolute;
        left: 0;
        top: 20%;
        bottom: 20%;
        width: 3px;
        background: linear-gradient(180deg, #24A1DE, #0ea5e9);
        border-radius: 2px;
        animation: slideInBar 0.25s ease;
    }

    @keyframes slideInBar {
        from { transform: scaleY(0); }
        to { transform: scaleY(1); }
    }

    .tg-service-pay-channel-content-v2 {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
    }

    .pay-channel-info-v2 {
        display: flex;
        flex-direction: column;
        gap: 1px;
        flex: 1;
        min-width: 0;
    }

    .tg-service-pay-channel-name-v2 {
        font-size: 14px;
        color: #374151;
        font-weight: 600;
        white-space: nowrap;
    }

    .pay-channel-tip-v2 {
        font-size: 11px;
        color: #94a3b8;
        font-weight: 400;
    }

    .tg-service-pay-channel-divider-v2 {
        height: 1px;
        background: linear-gradient(90deg, transparent, #f3f4f6 20%, #f3f4f6 80%, transparent);
        margin: 0;
    }

    .tg-service-pay-cards-inline-v2 {
        display: flex;
        align-items: center;
        gap: 3px;
    }

    .tg-service-pay-card-v2 {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 16px;
        gap: 12px;
        background: #ffffff;
        border-radius: 12px;
        border: 1px solid #e5e7eb;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
    }

    .tg-service-pay-price-v2 {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 4px;
    }

    .pay-label-v2 {
        font-size: 13px;
        color: #8e8e93;
        font-weight: 500;
    }

    .pay-amount-v2 {
        font-size: 32px;
        font-weight: 800;
        color: #f59e0b;
    }

    .tg-service-pay-btn-v2 {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        width: 100%;
        padding: 12px;
        background: linear-gradient(135deg, #24A1DE 0%, #0ea5e9 100%);
        color: #fff;
        border: none;
        border-radius: 10px;
        font-size: 15px;
        font-weight: 700;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        box-shadow: 0 3px 12px rgba(36, 161, 222, 0.3);
        transition: all 0.2s ease;
    }

    .tg-service-pay-btn-v2:active {
        transform: scale(0.98);
        box-shadow: 0 2px 8px rgba(36, 161, 222, 0.2);
    }

    .shimmer-effect-v2 {
        position: absolute;
        top: 0;
        left: -100%;
        width: 50%;
        height: 100%;
        background: linear-gradient(
                90deg,
                transparent,
                rgba(255, 255, 255, 0.25),
                transparent
        );
        animation: shimmer 2.5s infinite;
        pointer-events: none;
    }

    @keyframes shimmer {
        0% { left: -100%; }
        50% { left: 100%; }
        100% { left: 100%; }
    }

    .tg-service-detail-content {
        font-size: 14px;
        line-height: 1.8;
        color: #333;
        background: #ffffff;
        padding: 14px;
        border-radius: 12px;
        border: 1px solid #e5e7eb;
    }

    /* ========================================== */
    /* 板块三：订阅MTProto高速通道 */
    /* ========================================== */
    .tg-subscription-card {
        padding: 12px 12px;
    }

    .tg-sub-header {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 14px;
    }

    .tg-sub-icon-solid {
        width: 24px;
        height: 24px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #24A1DE, #1a8bc7);
        flex-shrink: 0;
    }

    .tg-sub-title {
        font-size: 16px;
        font-weight: 700;
        color: #24A1DE;
        letter-spacing: 0.3px;
    }

    .tg-pay-section-card {
        background: #ffffff;
        border-radius: 12px;
        border: 1px solid #e5e7eb;
        overflow: hidden;
        margin-bottom: 12px;
        transition: all 0.2s;
    }

    .tg-pay-row {
        display: flex;
        align-items: center;
        padding: 12px 14px;
        cursor: pointer;
        transition: all 0.2s;
        min-height: 48px;
        box-sizing: border-box;
    }

    .tg-pay-row.active {
        background: rgba(36, 161, 222, 0.06);
    }

    .tg-pay-content {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
    }

    .tg-pay-name {
        font-size: 14px;
        color: #374151;
        font-weight: 500;
        white-space: nowrap;
    }

    .tg-pay-cards-inline {
        display: flex;
        align-items: center;
        gap: 4px;
    }

    .tg-pay-divider {
        height: 1px;
        background: #e5e7eb;
        margin: 0;
    }

    .tg-sub-list {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .tg-sub-item.yellow {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 10px;
        background: #ffffff;
        border: 1px solid #e5e7eb;
        border-radius: 14px;
        cursor: pointer;
        transition: all 0.2s ease;
        position: relative;
    }

    .tg-sub-item.yellow:active {
        transform: scale(0.98);
        background: #f9fafb;
    }

    .tg-sub-main {
        display: flex;
        align-items: center;
        gap: 5px;
        flex: 1;
        min-width: 0;
        overflow: hidden;
    }

    .tg-sub-time {
        font-size: 13px;
        font-weight: 600;
        color: #1f2937;
        white-space: nowrap;
        flex-shrink: 0;
    }

    .tg-sub-divider {
        font-size: 11px;
        color: #d1d5db;
        flex-shrink: 0;
    }

    .tg-sub-label {
        font-size: 12px;
        color: #4b5563;
        white-space: nowrap;
        flex-shrink: 0;
    }

    .tg-sub-save.yellow {
        font-size: 10px;
        color: #d97706;
        background: rgba(251, 191, 36, 0.2);
        padding: 2px 5px;
        border-radius: 8px;
        font-weight: 500;
        white-space: nowrap;
        flex-shrink: 0;
    }

    .tg-sub-right {
        display: flex;
        align-items: center;
        gap: 16px;
        margin-left: 2px;
        flex-shrink: 0;
    }

    .tg-sub-price {
        font-size: 14px;
        font-weight: 700;
        color: #1f2937;
        white-space: nowrap;
    }

    .tg-sub-btn.yellow {
        font-size: 10px;
        color: #f59e0b;
        background: rgba(245, 158, 11, 0.1);
        padding: 4px 8px;
        border-radius: 12px;
        font-weight: 600;
        white-space: nowrap;
        border: 1px solid rgba(251, 191, 36, 0.4);
    }

    /* ========================================== */
    /* 板块四：邀请中心（统一浅蓝色） */
    /* ========================================== */
    .tg-invite-center-card {
        padding: 0;
        background: #ffffff;
        border: 1px solid #e0f2fe;
        overflow: hidden;
    }

    .tg-invite-center-top {
        padding: 12px 16px 1px 16px;
        background: linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%);
    }

    .tg-invite-center-bottom {
        padding: 12px 12px;
        background: linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%);
    }

    .tg-invite-center-divider {
        height: 1px;
        background: linear-gradient(to right,
        #ffffff 0%,
        #e0f2fe 16px,
        #e0f2fe calc(100% - 16px),
        #ffffff 100%
        );
        margin: 0;
    }

    .tg-invite-center-top .tg-invite-header {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 14px;
    }

    .tg-invite-center-top .tg-invite-icon-wrap {
        width: 22px;
        height: 22px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #0ea5e9, #0284c7);
        flex-shrink: 0;
    }

    .tg-invite-center-top .tg-invite-title {
        font-size: 16px;
        font-weight: 700;
        color: #24A1DE;
        letter-spacing: 0.3px;
    }

    .tg-invite-subtitle-inline {
        font-size: 13px;
        color: #24A1DE;
        font-weight: 500;
    }

    .tg-invite-center-top .tg-invite-loading {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 40px 20px;
        gap: 12px;
    }

    .tg-invite-center-top .tg-invite-loading .loading-text {
        font-size: 14px;
        color: #8e8e93;
    }

    .tg-invite-code-section-v2 {
        background: #ffffff;
        border-radius: 12px;
        padding: 14px 10px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
        border: 1px solid #e0f2fe;
        margin-bottom: 12px;
    }

    .tg-invite-code-main-v2 {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        margin-bottom: 12px;
    }

    .tg-invite-code-label-v2 {
        font-size: 14px;
        color: #6b7280;
        font-weight: 500;
        letter-spacing: 1px;
        text-align: center;
    }

    .tg-invite-code-text-v2 {
        font-size: 20px;
        font-weight: 700;
        color: #1f2937;
        letter-spacing: 3px;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
        text-shadow: 0 1px 2px rgba(0,0,0,0.05);
        text-align: center;
    }

    .tg-invite-divider-v2 {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        margin: 20px 0;
        padding: 0 20px;
    }

    .divider-line-v2 {
        height: 1px;
        flex: 1;
        max-width: 80px;
        background: linear-gradient(90deg, transparent, #cbd5e1 50%, transparent);
    }

    .divider-line-v2.left {
        background: linear-gradient(90deg, transparent, #0ea5e9);
    }

    .divider-line-v2.right {
        background: linear-gradient(90deg, #0ea5e9, transparent);
    }

    .divider-dot-v2 {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #0ea5e9;
        box-shadow: 0 0 8px rgba(14, 165, 233, 0.5);
    }

    .tg-invite-link-label-v2 {
        font-size: 14px;
        color: #6b7280;
        font-weight: 500;
        letter-spacing: 1px;
        text-align: center;
        margin-bottom: 10px;
    }

    .tg-invite-link-full {
        background: #f0f9ff;
        border-radius: 10px;
        padding: 10px 8px;
        border: 1px solid #bae6fd;
        margin-bottom: 10px;
        word-break: break-all;
    }

    .tg-invite-link-full-text {
        font-size: 12px;
        color: #0369a1;
        line-height: 1.5;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', monospace;
    }

    .tg-invite-copy-btn-bottom {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        width: 100%;
        padding: 10px 0;
        background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%);
        border: none;
        border-radius: 10px;
        color: #fff;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s;
        box-shadow: 0 2px 8px rgba(14, 165, 233, 0.3);
    }

    .tg-invite-copy-btn-bottom:active {
        transform: scale(0.98);
        opacity: 0.9;
    }

    .tg-invite-copy-btn-bottom.copied {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
    }

    .tg-invite-center-top .tg-invite-hint {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 12px;
        color: #6b7280;
        padding: 0 4px;
        margin-bottom: 12px;
    }

    .tg-invite-center-top .tg-invite-hint span {
        line-height: 1.4;
    }

    .tg-bind-success-banner {
        background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
        border: 1px solid #bae6fd;
        border-radius: 10px;
        padding: 10px 12px;
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .tg-bind-success-banner .bind-success-inner {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .tg-bind-success-banner .bind-success-icon {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: linear-gradient(135deg, #0ea5e9, #0284c7);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .tg-bind-success-banner .bind-success-text {
        display: flex;
        align-items: center;
        gap: 6px;
    }

    .tg-bind-success-banner .bind-success-label {
        font-size: 13px;
        color: #0369a1;
        font-weight: 500;
    }

    .tg-bind-success-banner .bind-success-code {
        font-size: 14px;
        color: #0ea5e9;
        font-weight: 700;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', monospace;
        letter-spacing: 1px;
    }

    .tg-invite-center-bottom .tg-referral-header {
        margin-bottom: 16px;
        display: flex;
        justify-content: flex-end;
    }

    .tg-view-history-btn {
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 4px 10px;
        background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%);
        color: #fff;
        border: none;
        border-radius: 10px;
        font-size: 11px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s ease;
        white-space: nowrap;
        flex-shrink: 0;
        box-shadow: 0 2px 6px rgba(14, 165, 233, 0.3);
    }

    .tg-view-history-btn:active {
        transform: scale(0.95);
        opacity: 0.9;
    }

    .tg-invite-center-bottom .tg-referral-stats {
        display: flex;
        align-items: stretch;
        justify-content: space-around;
        padding: 14px 10px;
        background: #ffffff;
        border-radius: 12px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
        border: 1px solid #e0f2fe;
    }

    .tg-invite-center-bottom .tg-referral-stat-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 4px;
        flex: 1;
        padding: 0 6px;
    }

    .tg-invite-center-bottom .tg-referral-stat-value {
        font-size: 16px;
        font-weight: 700;
        color: #1f2937;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        line-height: 1.2;
        text-align: center;
    }

    .tg-invite-center-bottom .tg-referral-stat-value.highlight {
        color: #0ea5e9;
    }

    .tg-invite-center-bottom .tg-referral-stat-header {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        width: 100%;
    }

    .tg-invite-center-bottom .tg-referral-stat-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 18px;
        height: 18px;
    }

    .tg-invite-center-bottom .tg-referral-stat-icon svg {
        width: 100%;
        height: 100%;
        display: block;
    }

    .tg-invite-center-bottom .tg-referral-stat-label {
        font-size: 12px;
        color: #6b7280;
        font-weight: 500;
        white-space: nowrap;
        letter-spacing: 0.5px;
    }

    .tg-invite-center-bottom .tg-referral-stat-divider {
        width: 1px;
        height: 36px;
        background: #e0f2fe;
        flex-shrink: 0;
        align-self: center;
    }

    @keyframes trophy-shine {
        0%, 100% { transform: rotate(-3deg) scale(1); }
        25% { transform: rotate(3deg) scale(1.05); }
        50% { transform: rotate(-3deg) scale(1); }
        75% { transform: rotate(3deg) scale(1.05); }
    }

    @keyframes fire-flicker {
        0%, 100% { transform: scaleY(1) scaleX(1); opacity: 1; }
        25% { transform: scaleY(1.15) scaleX(0.95); opacity: 0.9; }
        50% { transform: scaleY(1) scaleX(1.05); opacity: 1; }
        75% { transform: scaleY(1.1) scaleX(0.98); opacity: 0.95; }
    }

    @keyframes gift-bounce {
        0%, 100% { transform: translateY(0) scale(1); }
        40% { transform: translateY(-3px) scale(1.1); }
        60% { transform: translateY(-1px) scale(1.05); }
    }

    .tg-icon-trophy {
        animation: trophy-shine 2.5s ease-in-out infinite;
        transform-origin: center bottom;
    }

    .tg-icon-fire {
        animation: fire-flicker 1s ease-in-out infinite;
        transform-origin: center bottom;
    }

    .tg-icon-gift {
        animation: gift-bounce 1.8s ease-in-out infinite;
        transform-origin: center bottom;
    }

    /* ========================================== */
    /* 【新增】板块四-2：邀请奖励卡片样式 */
    /* ========================================== */
    .tg-rebate-card {
        padding: 0;
        background: #ffffff;
        border: 1px solid #fef3c7;
        overflow: hidden;
    }

    .tg-rebate-top {
        padding: 12px 16px 1px 16px;
        background: linear-gradient(135deg, #ffffff 0%, #fffbeb 100%);
    }

    .tg-rebate-bottom {
        padding: 12px 12px;
        background: linear-gradient(135deg, #ffffff 0%, #fffbeb 100%);
    }

    .tg-rebate-center-divider {
        height: 1px;
        background: linear-gradient(to right,
        #ffffff 0%,
        #fef3c7 16px,
        #fef3c7 calc(100% - 16px),
        #ffffff 100%
        );
        margin: 0;
    }

    .tg-rebate-header {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 14px;
    }

    .tg-rebate-icon-wrap {
        width: 22px;
        height: 22px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #f59e0b, #d97706);
        flex-shrink: 0;
    }

    .tg-rebate-title {
        font-size: 16px;
        font-weight: 700;
        color: #d97706;
        letter-spacing: 0.3px;
    }

    .tg-rebate-subtitle-inline {
        font-size: 13px;
        color: #d97706;
        font-weight: 500;
    }

    .tg-rebate-loading {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 40px 20px;
        gap: 12px;
    }

    .tg-rebate-loading .loading-text {
        font-size: 14px;
        color: #8e8e93;
    }

    /* 金额展示区域 */
    .tg-rebate-amount-section {
        background: #ffffff;
        border-radius: 12px;
        padding: 16px 10px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
        border: 1px solid #fef3c7;
        margin-bottom: 12px;
    }

    .tg-rebate-amount-main {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 6px;
        margin-bottom: 12px;
    }

    .tg-rebate-amount-label {
        font-size: 13px;
        color: #92400e;
        font-weight: 500;
        letter-spacing: 1px;
    }

    .tg-rebate-amount-value {
        display: flex;
        align-items: baseline;
        gap: 2px;
    }

    .tg-rebate-amount-value .amount-symbol {
        font-size: 20px;
        font-weight: 600;
        color: #d97706;
    }

    .tg-rebate-amount-value .amount-number {
        font-size: 32px;
        font-weight: 800;
        color: #d97706;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    }

    .tg-rebate-amount-divider {
        height: 1px;
        background: linear-gradient(90deg, transparent, #fef3c7 20%, #fef3c7 80%, transparent);
        margin: 0 0 12px 0;
    }

    .tg-rebate-amount-sub {
        display: flex;
        align-items: center;
        justify-content: space-around;
    }

    .tg-rebate-sub-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 4px;
    }

    .tg-rebate-sub-item .sub-label {
        font-size: 11px;
        color: #92400e;
        font-weight: 500;
    }

    .tg-rebate-sub-item .sub-value {
        font-size: 15px;
        font-weight: 700;
        color: #1f2937;
    }

    .tg-rebate-sub-item .sub-value.pending {
        color: #f59e0b;
    }

    /* 提现按钮 */
    .tg-rebate-withdraw-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        width: 100%;
        padding: 12px 0;
        border: none;
        border-radius: 10px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s;
        margin-bottom: 12px;
    }

    /* 提现按钮 - 立即提现（橙色，可点击） */
    .tg-rebate-withdraw-btn.active {
        background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
        color: #fff;
        box-shadow: 0 2px 8px rgba(245, 158, 11, 0.3);
    }

    .tg-rebate-withdraw-btn.active:active {
        transform: scale(0.98);
        opacity: 0.9;
    }

    /* 提现按钮 - 提现处理中（灰色，不可点击） */
    .tg-rebate-withdraw-btn.pending {
        background: #e5e7eb;
        color: #9ca3af;
        cursor: not-allowed;
        box-shadow: none;
    }

    /* 提现按钮 - 暂无可提现/金额不足（灰色，不可点击） */
    .tg-rebate-withdraw-btn.disabled {
        background: #f3f4f6;
        color: #9ca3af;
        cursor: not-allowed;
    }

    /* 提示 */
    .tg-rebate-hint {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 12px;
        color: #92400e;
        padding: 0 4px;
        margin-bottom: 12px;
    }

    .tg-rebate-hint span {
        line-height: 1.4;
    }

    /* 下部统计 */
    .tg-rebate-header-bottom {
        margin-bottom: 16px;
        display: flex;
        justify-content: flex-end;
    }

    .tg-view-rebate-btn {
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 4px 10px;
        background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
        color: #fff;
        border: none;
        border-radius: 10px;
        font-size: 11px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s ease;
        white-space: nowrap;
        flex-shrink: 0;
        box-shadow: 0 2px 6px rgba(245, 158, 11, 0.3);
    }

    .tg-view-rebate-btn:active {
        transform: scale(0.95);
        opacity: 0.9;
    }

    .tg-rebate-stats {
        display: flex;
        align-items: stretch;
        justify-content: space-around;
        padding: 14px 10px;
        background: #ffffff;
        border-radius: 12px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
        border: 1px solid #fef3c7;
    }

    .tg-rebate-stat-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 4px;
        flex: 1;
        padding: 0 6px;
    }

    .tg-rebate-stat-value {
        font-size: 16px;
        font-weight: 700;
        color: #1f2937;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        line-height: 1.2;
        text-align: center;
    }

    .tg-rebate-stat-value.highlight {
        color: #d97706;
    }

    .tg-rebate-stat-header {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        width: 100%;
    }

    .tg-rebate-stat-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 18px;
        height: 18px;
    }

    .tg-rebate-stat-icon svg {
        width: 100%;
        height: 100%;
        display: block;
    }

    .tg-rebate-stat-label {
        font-size: 12px;
        color: #92400e;
        font-weight: 500;
        white-space: nowrap;
        letter-spacing: 0.5px;
    }

    .tg-rebate-stat-divider {
        width: 1px;
        height: 36px;
        background: #fef3c7;
        flex-shrink: 0;
        align-self: center;
    }

    /* ========================================== */
    /* 【新增】奖励明细弹窗样式 */
    /* ========================================== */
    .tg-rebate-list-popup {
        border-radius: 16px 16px 0 0;
        display: flex;
        flex-direction: column;
    }

    .tg-rebate-list-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 20px;
        border-bottom: 1px solid #f3f4f6;
        background: #fff;
        flex-shrink: 0;
        height: 56px;
        box-sizing: border-box;
    }

    .tg-rebate-list-title {
        font-size: 17px;
        font-weight: 600;
        color: #1f2937;
    }

    .tg-rebate-list-scroll {
        padding: 0 16px;
        flex: 1;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        min-height: 0;
    }

    .tg-rebate-list-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 14px 0;
        border-bottom: 1px solid #f3f4f6;
    }

    .tg-rebate-list-item:last-child {
        border-bottom: none;
    }

    .tg-rebate-list-main {
        display: flex;
        flex-direction: column;
        gap: 6px;
        flex: 1;
        min-width: 0;
    }

    .tg-rebate-list-user {
        display: flex;
        align-items: center;
        gap: 6px;
    }

    .tg-rebate-list-user-text {
        font-size: 14px;
        font-weight: 600;
        color: #374151;
    }

    .tg-rebate-list-time {
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 12px;
        color: #9ca3af;
    }

    .tg-rebate-list-status {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 2px;
        flex-shrink: 0;
        margin-left: 12px;
    }

    .status-badge {
        font-size: 11px;           /* 【改大】原来是11px */
        font-weight: 600;
        padding: 3px 10px;         /* 【改大】原来是3px 10px */
        border-radius: 10px;       /* 【改大】原来是10px */
        white-space: nowrap;
        display: inline-block;
    }

    .status-badge.unsubscribed {
        background: #f3f4f6;
        color: #9ca3af;
    }

    .status-tags-row {
        display: flex;
        align-items: center;
        gap: 6px;                  /* 两个标签之间的间距 */
    }

    .status-badge.subscribed-text {
        background: #dcfce7;
        color: #16a34a;
    }

    .status-badge.withdraw-pending {
        background: #fef3c7;
        color: #d97706;
    }

    .status-badge.withdraw-done {
        background: #dbeafe;
        color: #2563eb;
    }

    .tg-rebate-loading-more {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 16px;
        color: #6b7280;
        font-size: 13px;
    }

    .tg-rebate-no-more {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 16px;
        color: #9ca3af;
        font-size: 13px;
    }

    .tg-rebate-list-empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 60px 20px;
        gap: 12px;
        flex: 1;
    }

    .tg-rebate-list-empty-text {
        font-size: 15px;
        color: #92400e;
        font-weight: 500;
    }

    .tg-rebate-list-empty-hint {
        font-size: 13px;
        color: #d97706;
    }

    /* ========================================== */
    /* 【新增】提现弹窗样式 */
    /* ========================================== */
    .tg-withdraw-dialog .van-dialog__content {
        padding: 0;
    }

    .tg-withdraw-content {
        padding: 16px 20px;
    }

    .tg-withdraw-balance {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 4px;
        padding: 12px;
        background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
        border-radius: 12px;
        margin-bottom: 16px;
        border: 1px solid #fde68a;
    }

    .balance-label {
        font-size: 13px;
        color: #92400e;
        font-weight: 500;
    }

    .balance-value {
        font-size: 28px;
        font-weight: 800;
        color: #d97706;
    }

    .tg-withdraw-input-group {
        margin-bottom: 16px;
    }

    .input-label {
        display: block;
        font-size: 13px;
        color: #374151;
        font-weight: 600;
        margin-bottom: 8px;
    }

    .input-wrapper {
        display: flex;
        align-items: center;
        background: #f9fafb;
        border: 1px solid #e5e7eb;
        border-radius: 10px;
        padding: 10px 12px;
        transition: all 0.2s;
    }

    .input-wrapper:focus-within {
        border-color: #f59e0b;
        background: #ffffff;
        box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.1);
    }

    .input-symbol {
        font-size: 16px;
        font-weight: 600;
        color: #d97706;
        margin-right: 8px;
    }

    .withdraw-input {
        flex: 1;
        border: none;
        background: transparent;
        font-size: 15px;
        color: #1f2937;
        outline: none;
    }

    .withdraw-input::placeholder {
        color: #9ca3af;
        font-size: 14px;
    }

    .input-all-btn {
        padding: 4px 10px;
        background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
        color: #fff;
        border: none;
        border-radius: 6px;
        font-size: 12px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s;
    }

    .input-all-btn:active {
        transform: scale(0.95);
        opacity: 0.9;
    }

    .input-hint {
        display: block;
        font-size: 11px;
        color: #9ca3af;
        margin-top: 4px;
    }

    .tg-withdraw-tips {
        background: #fffbeb;
        border: 1px solid #fde68a;
        border-radius: 10px;
        padding: 12px;
    }

    .tips-title {
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 12px;
        font-weight: 600;
        color: #92400e;
        margin-bottom: 8px;
    }

    .tips-content {
        font-size: 11px;
        color: #92400e;
        line-height: 1.6;
    }

    .tips-content p {
        margin: 0 0 4px 0;
    }

    .tips-content p:last-child {
        margin-bottom: 0;
    }

    /* ========================================== */
    /* 【新增】提现成功状态样式 */
    /* ========================================== */

    .tg-withdraw-success {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 24px 16px;
        gap: 12px;
        animation: successFadeIn 0.4s ease;
    }

    @keyframes successFadeIn {
        from { opacity: 0; transform: scale(0.95); }
        to { opacity: 1; transform: scale(1); }
    }

    .success-icon-wrap {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 4px;
        box-shadow: 0 4px 16px rgba(16, 185, 129, 0.2);
    }

    .success-title {
        font-size: 18px;
        font-weight: 700;
        color: #059669;
        margin-bottom: 4px;
    }

    .success-amount {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 4px;
        padding: 12px 24px;
        background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
        border-radius: 12px;
        border: 1px solid #fde68a;
        width: 100%;
    }

    .success-amount-label {
        font-size: 12px;
        color: #92400e;
        font-weight: 500;
    }

    .success-amount-value {
        font-size: 28px;
        font-weight: 800;
        color: #d97706;
    }

    .success-address {
        display: flex;
        flex-direction: column;
        gap: 4px;
        width: 100%;
        padding: 10px 12px;
        background: #f9fafb;
        border-radius: 10px;
        border: 1px solid #e5e7eb;
    }

    .success-address-label {
        font-size: 11px;
        color: #6b7280;
        font-weight: 500;
    }

    .success-address-value {
        font-size: 12px;
        color: #374151;
        font-family: monospace;
        word-break: break-all;
        line-height: 1.4;
    }

    .success-tips {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 10px 12px;
        background: #fffbeb;
        border-radius: 10px;
        border: 1px solid #fde68a;
        width: 100%;
        font-size: 13px;
        color: #92400e;
        font-weight: 500;
    }

    .success-notice {
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 11px;
        color: #9ca3af;
    }

    .tg-withdraw-btn-done {
        width: 100%;
        padding: 12px 0;
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        color: #fff;
        border: none;
        border-radius: 10px;
        font-size: 15px;
        font-weight: 600;
        cursor: pointer;
        margin-top: 8px;
        box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
        transition: all 0.2s;
    }

    .tg-withdraw-btn-done:active {
        transform: scale(0.98);
        opacity: 0.9;
    }

    /* ========================================== */
    /* 【新增】提现弹窗底部按钮 */
    /* ========================================== */
    .tg-withdraw-footer {
        display: flex;
        gap: 12px;
        margin-top: 16px;
        padding-top: 16px;
        border-top: 1px solid #f3f4f6;
    }

    .tg-withdraw-btn-cancel {
        flex: 1;
        padding: 11px 0;
        background: #f3f4f6;
        color: #6b7280;
        border: none;
        border-radius: 10px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s;
    }

    .tg-withdraw-btn-submit {
        flex: 1;
        padding: 11px 0;
        background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
        color: #fff;
        border: none;
        border-radius: 10px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        transition: all 0.2s;
        box-shadow: 0 2px 8px rgba(245, 158, 11, 0.3);
    }

    .tg-withdraw-btn-submit:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

    .tg-withdraw-btn-cancel:active {
        transform: scale(0.98);
        background: #e5e7eb;
    }

    .tg-withdraw-btn-submit:active:not(:disabled) {
        transform: scale(0.98);
        opacity: 0.9;
    }
    /* ========================================== */
    /* 邀请记录弹窗样式 */
    /* ========================================== */
    .tg-invite-history-popup {
        border-radius: 16px 16px 0 0;
        display: flex;
        flex-direction: column;
    }

    .tg-invite-history-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 20px;
        border-bottom: 1px solid #f3f4f6;
        background: #fff;
        flex-shrink: 0;
        height: 56px;
        box-sizing: border-box;
    }

    .tg-invite-history-title {
        font-size: 17px;
        font-weight: 600;
        color: #1f2937;
    }

    .tg-invite-history-scroll {
        padding: 0 16px;
        flex: 1;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        min-height: 0;
    }

    .tg-invite-history-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 14px 0;
        border-bottom: 1px solid #f3f4f6;
    }

    .tg-invite-history-item:last-child {
        border-bottom: none;
    }

    .tg-invite-history-main {
        display: flex;
        flex-direction: column;
        gap: 6px;
        flex: 1;
        min-width: 0;
    }

    .tg-invite-history-user {
        display: flex;
        align-items: center;
        gap: 6px;
    }

    .tg-invite-history-user-text {
        font-size: 14px;
        font-weight: 600;
        color: #374151;
    }

    .tg-invite-history-time {
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 12px;
        color: #9ca3af;
    }

    .tg-invite-history-gift {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 2px;
        flex-shrink: 0;
        margin-left: 12px;
    }

    .tg-invite-history-gift-label {
        font-size: 11px;
        color: #9ca3af;
    }

    .tg-invite-history-gift-days {
        font-size: 15px;
        font-weight: 700;
        color: #f59e0b;
    }

    .tg-history-loading-more {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 16px;
        color: #6b7280;
        font-size: 13px;
    }

    .tg-history-no-more {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 16px;
        color: #9ca3af;
        font-size: 13px;
    }

    .tg-invite-history-empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 60px 20px;
        gap: 12px;
        flex: 1;
    }

    .tg-invite-history-empty-text {
        font-size: 15px;
        color: #6b7280;
        font-weight: 500;
    }

    .tg-invite-history-empty-hint {
        font-size: 13px;
        color: #9ca3af;
    }

    /* ========================================== */
    /* 板块五：版权信息 Footer */
    /* ========================================== */
    .tg-footer-section {
        margin-top: 10px;
        margin-bottom: 10px;
        padding: 5px 0;
    }

    .tg-footer-content {
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2px;
    }

    .tg-footer-version {
        font-size: 14px;
        color: #8e8e93;
        font-weight: 400;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        line-height: 1.4;
    }

    .tg-footer-domain {
        font-size: 14px;
        color: #8e8e93;
        font-weight: 400;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        line-height: 1.4;
    }

    /* ========================================== */
    /* 更新提醒条 */
    /* ========================================== */
    .tg-update-bar {
        position: fixed;
        bottom: 66px;
        left: 0;
        right: 0;
        height: 63px;
        background: linear-gradient(to right, #4ade80 0%, #2dd4bf 50%, #14b8a6 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 999;
        cursor: pointer;
        transition: all 0.3s ease;
    }

    .tg-update-bar:active {
        opacity: 0.9;
    }

    .tg-update-content {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
    }

    .tg-update-icon {
        width: 28px;
        height: 28px;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .tg-update-icon svg {
        color: #10b981;
        width: 16px;
        height: 16px;
    }

    .tg-update-text {
        font-size: 16px;
        color: #fff;
        font-weight: 500;
        white-space: nowrap;
    }

    /* ========================================== */
    /* 支付弹窗 */
    /* ========================================== */
    .tg-dialog-header {
        font-size: 17px;
        font-weight: 600;
        color: #1f2937;
        padding: 0 0 8px;
    }

    .tg-qr-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 10px;
    }

    .tg-qr-box {
        padding: 16px;
        background: #fff;
        border-radius: 16px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        margin-bottom: 16px;
    }

    .tg-qr-hint {
        font-size: 13px;
        color: #6b7280;
    }

    .crypto-dialog {
        max-height: 97vh;
        overflow: hidden;
        margin-top: auto !important;
        margin-bottom: auto !important;
        top: calc(50% - 32px) !important;
    }

    .tg-crypto-wrapper {
        padding: 0px 16px 16px;
    }

    .crypto-pay-card {
        background: linear-gradient(135deg, #f0fdf4 0%, #ffffff 100%);
        border: 1px solid #bbf7d0;
        border-radius: 10px;
        padding: 7px 12px;
        margin-bottom: 12px;
    }

    .crypto-pay-amount {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        margin-bottom: 4px;
    }

    .crypto-amount-label {
        font-size: 13px;
        color: #6b7280;
        font-weight: 500;
    }

    .crypto-amount-value {
        display: flex;
        align-items: baseline;
        gap: 2px;
    }

    .amount-number {
        font-size: 24px;
        font-weight: 700;
        color: #059669;
    }

    .amount-unit {
        font-size: 14px;
        font-weight: 600;
        color: #10b981;
    }

    .crypto-amount-cny {
        font-size: 12px;
        color: #6b7280;
        text-align: center;
    }

    .crypto-countdown {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        font-size: 11px;
        color: #ef4444;
        font-weight: 500;
        margin-top: 4px;
    }

    .crypto-loading-section {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 30px 20px;
        margin-bottom: 12px;
    }

    .crypto-loading-text {
        margin-top: 10px;
        font-size: 14px;
        color: #6b7280;
    }

    .crypto-error-section {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 30px 20px;
        margin-bottom: 12px;
        text-align: center;
    }

    .crypto-error-text {
        margin-top: 10px;
        font-size: 14px;
        color: #374151;
        line-height: 1.5;
    }

    .crypto-retry-btn {
        display: flex;
        align-items: center;
        gap: 6px;
        margin-top: 16px;
        padding: 10px 20px;
        background: #3b82f6;
        color: #fff;
        border: none;
        border-radius: 10px;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
    }

    .crypto-retry-btn:active {
        opacity: 0.9;
        transform: scale(0.98);
    }

    .crypto-qr-section {
        margin-bottom: 12px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .crypto-qr-box {
        position: relative;
        width: 140px;
        height: 140px;
        margin: 0 auto 8px;
        background: #fff;
        border-radius: 10px;
        padding: 8px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .crypto-qr-img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        border-radius: 4px;
    }

    .crypto-network-badge {
        position: absolute;
        bottom: 6px;
        right: 6px;
        background: #10b981;
        color: #fff;
        font-size: 9px;
        font-weight: 600;
        padding: 2px 6px;
        border-radius: 10px;
    }

    .crypto-qr-hint {
        text-align: center;
        font-size: 12px;
        color: #6b7280;
    }

    .crypto-address-section {
        margin-bottom: 12px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .crypto-address-label {
        font-size: 12px;
        color: #6b7280;
        margin-bottom: 8px;
        text-align: center;
    }

    .crypto-address-capsule {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
        width: 100%;
    }

    .crypto-address-pill {
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        border: 1.5px solid #e2e8f0;
        border-radius: 25px;
        padding: 12px 6px;
        width: auto;
        min-width: 280px;
        max-width: 80%;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    }

    .crypto-address-text {
        font-size: 11px;
        color: #374151;
        font-family: monospace;
        font-weight: 500;
        letter-spacing: 0.5px;
        white-space: nowrap;
        text-align: center;
        line-height: 1.4;
    }

    .crypto-copy-capsule {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 8px 24px;
        background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
        color: #fff;
        border: none;
        border-radius: 20px;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
        transition: all 0.2s ease;
    }

    .crypto-copy-capsule:active {
        transform: scale(0.96);
        box-shadow: 0 1px 4px rgba(59, 130, 246, 0.3);
    }

    .crypto-status-box {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        padding: 10px 12px;
        border-radius: 8px;
        margin-bottom: 12px;
        font-size: 13px;
        font-weight: 500;
    }

    .crypto-warning-box {
        display: flex;
        gap: 4px;
        padding: 4px 4px;
        background: #fffbeb;
        border: 1px solid #fcd34d;
        border-radius: 8px;
        width: 96%;
        margin: 0 auto;
    }

    .crypto-warning-text {
        flex: 1;
        font-size: 11px;
        color: #92400e;
        line-height: 1.5;
    }

    .crypto-warning-text p {
        margin: 0 0 2px 0;
    }

    .crypto-warning-text p:last-child {
        margin-bottom: 0;
    }
</style>

